import type { UserProfileSchema } from '@rhybus/user-profile'
import { I_Announcement } from '../interfaces'
import { getListName } from '../utils/listNameUtils'
// import { DashboardFieldConfig } from '@rhybus/announcements/dist/component/announcements-dashboard'
import { MetadataConfig } from '@rhybus/metadata-management'
import { InnerViewFieldConfig } from '@rhybus/qanda'
import { SiteFeedbackFieldConfig } from '@rhybus/site-feedback'
import type { AnnouncementItem, AttachmentFileItem, ContentManagementTabKey, KnowledgeGraphItem, QaItem, QuickLinkItem } from '../services/contentManagement'
import React, { createElement } from 'react'
import { convertDate, DocumentIconNames, removeEmptyTags ,removehtmltags} from '@rhybus/common-functions'
import {
  TT_FORM_BASE_START_DATE,
  TT_FORM_BASE_END_DATE,
  TT_FORM_BASE_COST,
  TT_FORM_REQUESTED_POP,
  TT_FORM_REQUESTOR_PHONE,
  TT_FORM_POC_NAME,
  TT_FORM_POC_PHONE,
  TT_FORM_OTHER_NAME,
  TT_FORM_OTHER_ROLE,
  TT_FORM_OTHER_PHONE,
  TT_FORM_CTR_SUPPORT_REQUIRED,
  TT_FORM_CTR_VENDOR,
  TT_FORM_CTR_SUPPORT,
  TT_FORM_REQUIREMENT_DESCRIPTION,
  TT_FORM_IMPACT_STATEMENT,
  TT_FORM_LEVEL_OF_URGENCY,
  TT_FORM_SCOPE_OF_WORK,
  TT_FORM_OTHER_BRANCHES,
  TT_FORM_SOLE_SOURCE_REQUIRED,
  TT_FORM_REQUESTED_VENDOR,
  TT_FORM_SOLE_SOURCE_JUSTIFICATION,
  TT_FORM_BRAND_NAME_REQUIRED,
  TT_FORM_REQUESTED_PRODUCT,
  TT_FORM_BRAND_NAME_JUSTIFICATION,
  TT_FORM_JUSTIFICATION_DOCUMENT,
  TT_FORM_ACQUISITION_METHOD,
  TT_FORM_UFMS_TARGET_DATE,
  TT_FORM_REQUISITION_NUMBER,
  TT_FORM_BUDGET_REFERENCE,
  TT_FORM_INVESTMENT,
  TT_FORM_CONTRACT_SPECIALIST,
  TT_FORM_AWARD_VENDOR,
  TT_FORM_CONTRACT_START_DATE,
  TT_FORM_CONTRACT_END_DATE,
  TT_FORM_HHS_AWARD_NUMBER,
  TT_FORM_OBJECT_CLASS,
  TT_FORM_MASTER_OBJECT_CLASS,
  TT_FORM_START_DATE,
  TT_TRAINING_USER_CASE_ID,
  TT_TRAINING_LINE,
  TT_TRAINING_TYPE,
  TT_TRAINING_WCN,
  TT_TRAINING_PRIORITY,
  TT_TRAINING_FISCAL_YEAR,
  TT_TRAINING_QUARTER,
  TT_TRAINING_RANK,
  TT_TRAINING_TPC,
  TT_TRAINING_STUDENT_FIRST_NAME,
  TT_TRAINING_STUDENT_MIDDLE_NAME,
  TT_TRAINING_STUDENT_LAST_NAME,
  TT_TRAINING_VETTED,
  TT_TRAINING_SUFFIX,
  TT_TRAINING_TMASL,
  TT_TRAINING_LOCATION,
  TT_TRAINING_EXA,
  TT_TRAINING_REPORT_DATE,
  TT_TRAINING_END_DATE,
  TT_TRAINING_DURATION,
  TT_TRAINING_DURATION_TYPE,
  TT_TRAINING_CLASS_ID,
  TT_TRAINING_STATUS,
  TT_TRAINING_FINANCIAL_STATUS,
  TT_TRAINING_FACILITY,
  TT_TRAINING_DESCRIPTION,
  TT_TRAINING_ATTACHMENTS,
  TOOLTIP_DEFAULTS
} from '../services/tooltip-ids'
import { KpisData } from './data'
import type { ReleaseNoteItem } from '../services/releaseNotes'
import type { PersonData, UserInfo, UserManagementConfig } from '../services/userManagement'
import { rhybusWhoHttp } from '../api/rhybus-who-http'
import { IUser } from '@rhybus/api/dist/rhybus'
export const DELETE_ITEM = 'Are You Sure Delete Item'

export const GENERAL_USER_GROUP = 'All Users'
export const VALIDATE_PII_CONTENT = true
export const VALIDATE_PII_CONTENT_DISCUSSIONS = true
export const VALIDATE_PII_CONTENT_FILES = true
export const COMMENT_TO_IN_DISCUSSIONS = true
export const FullControlUserGroups = ['ReactTemplate Owners', 'ReactTemplate1Int Owners']
export const APP_CONFIG_GROUP = ['Rhybus Admin']

export const UserRoles = {
  BUSINESS_OWNERS: 'Business Owners',
  SUBMITTER: 'Submitter',
  PM_VALIDATION: 'PM Validation',
  IM_IT: 'IM_IT',
  RM: 'RM',
  DCS_PROCUREMENT: 'DCS Procurement',
  AGREEMENTS_REVIEW_IAA: 'Agreements review IAA',
  LEGAL: 'Legal',
  CMRA: 'CMRA',
  SPACE_UTILIZATION: 'Space Utilization',
  MANPOWER: 'Manpower',
  AT_OPSEC: 'AT_Opsec',
  UNIT_HEAD: 'Unit Head',
  DEPUTY_DIRECTOR: 'Deputy_Director',
  FM_RM: 'FM_RM'
} as const
export const UPDATE_BUILD_VERSION = 'Are you sure, you want to update the Build version?'
export const DELETE_MSG = 'Are you sure, you want to delete the selected item?'
export const CLOSE_MSG = 'Are you sure you want to close the page?'
export const CALENDAR_EVENT_MSG = 'Are you sure, you want to delete this calendar event?'
export const NO_CHANGE_MSG = 'No changes detected'
export const SELECT_ITEM = 'Select a item to continue'
export const SELECT_ONE_ITEM = 'Please select at least one document.'
export const SELECT_TEAM_MEBR = 'Please select at least one team member to delete.'
export const DELETE_TEAM_MEBR = 'Are you sure you want to delete the selected team member(s)?'
export const MAX_NUM_FILES = 10
export const MAX_FILE_SIZE = 26214400 // 25 MB
export const ACCEPTABLE_FILE_TYPES = [
  'xlsx', 'xls', 'doc', 'docx', 'ppt', 'pptx',
  'txt', 'pdf', 'png', 'jpg', 'jpeg', 'gif', 'msg'
]
export const FILE_CHARACTERS_UNALLOWED = [',', '!', '@', '#', '$', '%', '^', '&', '*', '(', ')', '+', '=', '[', ']', '{', '}', 'ʻ', ':', '“', '|', '<', '>', '/', '?', '~']
export const COMMONMETADATA_SELECT_COLUMNS = ['ID', 'MetadataType', 'InternalCode', 'MetadataValue', 'MetadataDescription', 'AdditionalValue1', 'AdditionalValue2', 'AllowEdit', 'IsArchived', 'ItemModified', 'ItemCreatedBy/Title', 'ItemModifiedBy/Title']
export const OVERRIDE_METADATA = 'Are you sure, you want to override all Metadata?'
export const COMPLETED_MESSAGE = 'Completed'
export const FILE_HINT_MSG = 'Upload the files which are in the .xlsx, .xls, .doc, .docx, .ppt, .pptx, .txt, .pdf, .png, .jpg, .jpeg, .gif, .msg and special characters will not be used in the document names. Maximum size for file is 25 MB. Limit is up to 10 files per screen.'
// Error/Confirmation display messages
export const SELECT_MESSAGE = 'Please select'
export const ENTER_MSG = 'Please enter'
export const SELECT_DATE = 'Please select date'
export const ENTER_MAIL_ID = 'Please eneter valid mail ID'
export const NORESULT = 'There are no results to display'
export const FILENAME_REGEX = /['~#%{}+]|\\.\\.|^\\.|\\.$/
export const UPDATE_ALERT = 'No Changes Detected'
//Success Messages
export const SuccessMsg = {
  ANNOUNCEMENT_SUBMIT_SUCCESS_MSG: 'Announcement added Successfully',
  ANNOUNCEMENT_UPDATE_SUCCESS_MSG: 'Announcement updated Successfully',
  ANNOUNCEMENT_DELETE_SUCCESS_MSG: 'Announcement deleted Successfully',
  KNOWLEDGEGRAPH_SUBMIT_SUCCESS_MSG: 'Knowledge Base added Successfully',
  KNOWLEDGEGRAPH_UPDATE_SUCCESS_MSG: 'Knowledge Base updated Successfully',
  KNOWLEDGEGRAPH_DELETE_SUCCESS_MSG: 'Knowledge Base deleted Successfully',
  QA_SUBMIT_SUCCESS_MSG: 'Q&A added Successfully',
  QA_UPDATE_SUCCESS_MSG: 'Q&A updated Successfully',
  QA_DELETE_SUCCESS_MSG: 'Q&A deleted Successfully',
  Quicklinks_SUBMIT_SUCCESS_MSG: 'Submitted Quicklinks are listed in alphabetical order by name',
  Quicklinks_UPDATE_SUCCESS_MSG: 'Updated Quicklinks are listed in alphabetical order by name',
  Quicklinks_DELETE_SUCCESS_MSG: 'Quicklinks deleted Successfully',
  POC_SUBMIT_SUCCESS_MSG: 'Submitted POCs are listed in alphabetical order by name',
  POC_UPDATE_SUCCESS_MSG: 'Updated POCs are listed in alphabetical order by name',
  POC_DELETE_SUCCESS_MSG: 'Points Of Contact deleted Successfully',
  PMG_FOLDER_SUBMIT_SUCCESS_MSG: 'Created Folders are listed in alphabetical order',
  PMG_FOLDER_UPDATE_SUCCESS_MSG: 'Updated Folders are listed in alphabetical order',
  PMG_FOLDER_DELETE_SUCCESS_MSG: 'Folder deleted Successfully',
  PMG_FILE_SUBMIT_SUCCESS_MSG: 'Submitted Files are listed in alphabetical order',
  PMG_FILE_UPDATE_SUCCESS_MSG: 'Updated Files are listed in alphabetical order',
  PMG_FILE_DELETE_SUCCESS_MSG: 'File deleted Successfully',
} as const

// eslint-disable-next-line no-redeclare
export type SuccessMsg =
  typeof SuccessMsg[keyof typeof SuccessMsg]

// Submission Type Info
export const Submission = {
  SAVE: 'Save',
  SUBMIT: 'Submit',
  UPDATE: 'Update',
  FOLDER_SUBMIT: 'FolderSubmit',
  FOLDER_UPDATE: 'FolderUpdate',
  FOLDER_DELETE: 'FolderDelete',
  FILE_SUBMIT: 'FileSubmit',
  FILE_UPDATE: 'FileUpdate',
  FILE_DELETE: 'FileDelete'
}

/// / Backend call status
export const FetchStatus = {
  SUCCESS: 'Success',
  LOADING: 'Loading',
  FAILED: 'Failed'
} as const

// eslint-disable-next-line no-redeclare
export type FetchStatus =
  typeof FetchStatus[keyof typeof FetchStatus];

/// / Display types
export const Display = {
  PAGE: 'Page',
  TILE: 'Tile'
}

/// / List Names
export const ListNames = {
  MASTERLIST: getListName('MasterList'),
  GRANTLIST: getListName('GrantsList'),
  DISCUSSION: getListName('DSCADiscussionsList'),
  DOCUMENT_LIBRARY: getListName('DocumentLibrary'),
  TEAMMEMBERS: getListName('DSCATeamMembersList'),
  EMAILLOGLIST: getListName('EmailLogList'),
  HISTORYLIST: getListName('HistoryList'),
  NOTIFICATION: getListName('DSCANotificationsList'),
  NOTIFICATION_METADATA: getListName('DSCANotificationsMetadataList'),
  ANNOUNCEMENT: getListName('AnnouncementList'),
  KNOWLEDGEGRAPH: getListName('KnowledgeBaseArticles'),
  CALENDAR: getListName('CalendarList'),
  QUICK_LINK: getListName('QuickLinkList'),
  POINT_OF_CONTACT: getListName('PointOfContactList'),
  REVIEW_MEETING_SCHEDULE: getListName('ReviewMeetingSchedule'),
  QANDA: getListName('QAndAList'),
  HELPDESK: getListName('HelpDeskList'),
  FEEDBACK: getListName('SiteFeedbackList'),
  POLICY_MEMO: getListName('PolicyMemoAndGuidelinesList'),
  FORM_SCHEMA_HISTORY: getListName('FormSchemaHistory'),
  TOOLTIP: getListName('ToolTipList'),
  FEEDBACK_ABOUT_METADATA: getListName('FeedbackAboutMetadata'),
  PIICATEGORY: getListName('PIICategory'),
  PIICATEGORYTYPE: getListName('PIICategoryType'),
  PIIAUDITTRAIL: getListName('PIIAuditTrailList'),
  PII_FORMATS: getListName('PIIFormates'),
  COMMON_METADATA: getListName('DSCACommonMetadataList'),
  CLASSIFICATION_BANNER: getListName('ClassificationBanner'),
  LOGO: getListName('LogoList'),
  RELEASE_NOTES: getListName('ReleaseNotesList'),
  RHYBUS_ACCESS_GROUPS: getListName('RhybusAccessGroupsList'),
  USERPREFERENCES: getListName('UserPreferences'),
  USERPROFILE: getListName('UserProfileList'),
  EXPORT_COLUMN_CONFIGURATION: getListName('ExportColumnConfiguration'),
  CONTRACT_DURATION: getListName('ContractDurationList'),
  REQUISITION_NUMBER: getListName('RequisitionNumberList'),
  BUILD_MODIFIED_LIST: getListName('BuildVersionModifiedList'),
  CHECKLIST: getListName('CheckListMetaData'),
  CHECKLIST_SUBMISSIONS: getListName('CheckList'),
  DSCA_CASE_MASTER: getListName('DSCACaseMaster'),
  DSCA_CASE_MASTER_LINE: getListName('DSCACaseMasterLine'),
  DSCA_CASE_HISTORY: getListName('DSCACaseHistoryList'),
  DSCA_TRAINING_TRACK: getListName('DSCATrainingTrack'),
  DSCA_TRAINING_TRACK_LINE: getListName('DSCATrainingTrackLine'),
  DSCA_TRAINING_HISTORY: getListName('DSCATrainingHistoryList'),
  DSCA_SECURITY_GROUP_METADATA: getListName('DSCASecurityGroupMetadata'),
  DSCA_TOOLTIP: getListName('DSCATooltipMetadataList')
}

/// / Sharepoint constants
export const SHAREPOINT_NAV_ICON_STATE = {
  SHOW: 'Show',
  HIDE: 'Hide'
}
export const SHAREPOINT_PERMISSION_LEVELS = {
  Contribute: 'Contribute',
  FullControl: 'FullControl',
  Design: 'Design',
  Edit: 'Edit',
  Read: 'Read',
  ViewOnly: 'ViewOnly',
}

export const SHAREPOINT_PERMISSION_LEVELS_IDS = {
  Contribute: 1073741827,
  FullControl: 1073741829,
  Design: 1073741828,
  Edit: 1073741830,
  Read: 1073741826,
  ViewOnly: 1073741924
}
export const COPY_TO = ['PreviousStatusTitle', 'StatusTitle', 'ItemGUID', 'Title', 'AppTitle', 'ItemCreated', 'ItemCreatedById', 'ItemModified', 'ItemModifiedById']
export const NO_OF_ANNOUNCEMENTS_DISPLAY_IN_HOMEPAGE = 3
export const NO_OF_KNOWLEDGEARTICLES_DISPLAY_IN_HOMEPAGE = 4
export const NO_OF_POINTS_OF_CONTACTS_DISPLAY_IN_HOMEPAGE = 3
export const NO_OF_QUICKLINKS_DISPLAY_IN_HOMEPAGE = 10
export const NO_OF_QA_DISPLAY_IN_HOMEPAGE = 3
export const NO_OF_CALENDAR_DISPLAY_IN_HOMEPAGE = 3

// Settings lists configurations
export const ANNOUNCEMENTS_SELECT_COLUMNS = ['ID', 'Id', 'Title', 'IsArchived', 'Description', 'Tags', 'ExpiryDate', 'ItemCreated', 'ItemCreatedBy/Title', 'ItemModified', 'ItemModifiedBy/Title', 'AttachmentFiles']
export const KNOWLEDGEGRAPH_SELECT_COLUMNS = ['ID', 'Id', 'Title', 'IsArchived', 'Description', 'FY', 'Role', 'Tags', 'ItemCreated', 'ItemCreatedBy/Title', 'ItemModified', 'ItemModifiedBy/Title', 'AttachmentFiles']
export const QANDA_SELECT_COLUMNS = ['ID', 'Id', 'Title', 'Answer', 'Question', 'IsArchived', 'Description', 'Tags', 'ItemCreated', 'ItemCreatedBy/Title', 'ItemModified', 'ItemModifiedBy/Title', 'AttachmentFiles']
export const POC_SELECT_COLUMNS = ['ID', 'Id', 'Title', 'ContactName', 'ContactTitle', 'ContactEmail', 'ContactPhone', 'IsArchived', 'ItemCreated', 'ItemCreatedBy/Title', 'ItemModified', 'ItemModifiedBy/Title', 'Modified', 'Editor/Title']
export const QUICKLINKS_SELECT_COLUMNS = ['ID', 'Id', 'Title', 'Info', 'URL', 'IsArchived', 'ItemCreated', 'ItemCreatedBy/Title', 'ItemModified', 'ItemModifiedBy/Title', 'Modified', 'Editor/Title']
export const CALENDAR_SELECT_COLUMNS = ['ID', 'Id', 'BannerUrl', 'Category', 'Overbook', 'Created', 'Description', 'EndDate', 'RRule', 'Geolocation', 'Location', 'StartDate', 'Title', 'ItemCreated', 'ItemModified', 'ItemCreatedBy/Title', 'ItemModifiedBy/Title', 'Recurrence', 'IsAllDayEvent', 'DateRange']
export const HELPDESK_SELECT_COLUMNS = ['ID', 'Id', 'Title', 'EmailAddress', 'hoursOfOperation', 'PhoneNo', 'ItemCreated', 'ItemCreatedBy/Title', 'ItemModified', 'ItemModifiedBy/Title']
export const SITE_FEEDBACK_SELECT_COLUMNS = ['ID', 'Id', 'Title', 'Message', 'Subject', 'FeedBackAbout', 'ItemCreated', 'ItemCreatedBy/Title', 'ItemModified', 'ItemModifiedBy/Title']
export const SITE_FEEDBACK_ABOUT_SELECT_COLUMNS = ['ID', 'Id', 'Title', 'IsArchived', 'ItemCreated', 'ItemCreatedBy/Title', 'ItemModified', 'ItemModifiedBy/Title']
export const TOOLTIPS_SELECT_COLUMNS = ['ID', 'Id', 'Title', 'ToolTipID', 'LabelName', 'TooltipDescription', 'ItemCreated', 'ItemCreatedBy/Title', 'ItemModified', 'ItemModifiedBy/Title']
export const POLICY_MEMO_SELECT_COLUMNS = ['Exists', 'Name', 'ServerRelativeUrl', 'TimeCreated', 'TimeLastModified', 'UniqueId', 'ItemCreatedBy/Title', 'ItemModifiedBy/Title']
export const BANNER_SELECT_COLUMNS = ['ID', 'Id', 'ClassificationMessage', 'ClassificationColor', 'TextColor', 'ItemCreated', 'ItemModified', 'ItemCreatedBy/Title', 'ItemModifiedBy/Title']
export const LOGO_SELECT_COLUMNS = ['ID', 'Id', 'AttachmentsType', 'AttachmentFiles', 'ItemCreated', 'ItemModified', 'ItemCreatedBy/Title', 'ItemModifiedBy/Title']
export const RELEASE_NOTES_SELECT_COLUMNS = ['ID', 'Id', 'IsArchived', 'VersionName', 'NewFeatures', 'ResolvedIssues', 'KnownIssues', 'ItemCreated', 'ItemModified', 'ItemCreatedBy/Title', 'ItemModifiedBy/Title', 'ReleaseDate']
export const RHYBUS_ACCESS_GROUPS_SELECT_COLUMNS = ['ID', 'Id', 'GroupName']

// Application lists Configurations
export const MASTERLIST_SELECT_COLUMNS = ['ID', 'Title', 'ItemGUID', 'RequestID', 'StatusCode', 'StatusTitle', 'PreviousStatusCode', 'PreviousStatusTitle', 'RequirementTitle', 'Product', 'TBM', 'Division', 'Branch', 'NeedByDate', 'EstimatedCurrentYearCost', 'ITARNumber', 'FY', 'RequirementDescription', 'RequestorPhoneNumber', 'POCName', 'POCPhoneNumber', 'OtherName', 'OtherRole', 'OtherPhoneNumber', 'RequiresCTRSupport', 'SupportingCTRVendor', 'DescribeThatSupport', 'ImpactStatement', 'LevelOfUrgency', 'ScopeOfWork', 'SoleSourceJustifications', 'SoleSourceRequired', 'RequestedVendor', 'DescribeWhySoleSource', 'BrandNameJustifications', 'DescribeWhy', 'AcquisitionMethod', 'UFMSTargetDate', 'RequisitionNumber', 'BudgetReference', 'Investment', 'ContractSpecialist', 'AwardedVendor', 'ContractStartDate', 'ContractEndDate', 'IIISAwardNumber', 'ObjectClass', 'MasterObjectClass', 'COR/Title', 'COR/Id', 'RequestedAmount', 'RevisedAmount', 'FundedAmount', 'UnfundedAmount', 'ItemCreated', 'ItemCreatedBy/Title', 'ItemCreatedBy/ID', 'ItemModified', 'ItemModifiedBy/Title', 'IsFormSubmitted', 'IsFormSaved']
export const MASTERLIST_EXPAND_COLUMNS = 'ItemCreatedBy, ItemModifiedBy, COR'
export const HISTORYLIST_SELECT_COLUMNS = ['ID', 'Id', 'Title', 'ItemGUID', 'AppID', 'StatusCode', 'StatusTitle', 'PreviousStatusCode', 'PreviousStatusTitle', 'Comment', 'Action', 'AssignedTo/Title', 'AssignedTo/Id']
export const DISCUSSIONLIST_SELECT_COLUMNS = ['ID', 'Id', 'Title', 'ItemGUID', 'AppID', 'Subject', 'Comment', 'IsActionComment', 'ParentCommentID', 'UserRole/Id', 'UserRole/Title', 'CommentType', 'DocumentName', 'ItemCreated', 'ItemCreatedBy/Title', 'ItemModified', 'ItemModifiedBy/Title', ...(COMMENT_TO_IN_DISCUSSIONS ? ['CommentTo'] : [])]
export const TEAMMEMBERSLIST_SELECT_COLUMNS = 'ID, Id, Title, ItemGUID, AppID, TeamMembers, TeamMembers/Title, TeamMembers/ID, TeamMembers/EMail'
export const EMAILLOGLIST_SELECT_COLUMNS = ['ID', 'Id', 'Title', 'Role', 'ToUser', 'Action', 'Subject', 'From', 'To', 'ItemCreated', 'ItemCreatedBy/Title', 'ItemModified', 'ItemModifiedBy/Title', 'ItemGUID', 'AppID', 'Body', 'IsMailSent', 'ErrorInformation']
export const NOTIFICATION_SELECT_COLUMNS = ['ID', 'Id', 'Title', 'Read/Title', 'Read/Id', 'Role', 'ToUserRole', 'Subject', 'NotificationType', 'ItemCreated', 'ItemCreatedBy/Title', 'ItemModified', 'ItemModifiedBy/Title', 'Status', 'Activity', 'ItemGUID', 'AppID', 'ToUser', 'IsRead']
export const NOTIFICATION_EXPAND_COLUMNS = 'ItemCreatedBy, ItemModifiedBy,Read'
export const DOCUMENT_LIBRARY_SELECT_COLUMNS = 'Exists, Name, ServerRelativeUrl, TimeCreated, TimeLastModified, UniqueId, ItemCreatedBy/Title,ItemModifiedBy/Title'
// Header Values configuration
export const TABLE_HEADERS = ['Heading 1', 'Heading 2', 'Heading 3', 'Heading 4', 'Heading 5', 'Heading 6', 'Heading 7', 'Heading 8', 'Heading 9', 'Heading 10', 'Heading 11', 'Status']

export const STATUS_COLORS_ENUM: any = {
  'Submitted': '#2DACD3',
  'Copied': '#C3711F',
  'Completed': '#3eaa24',
  'Saved': '#000000'
}
export const PIE_CHART_COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042']
export const RADIAN = Math.PI / 180
export const AttachmentsType = {
  Banner: 'Banner',
  Logo: 'Logo'
}
export const DiscussionType = {
  PUBLIC: 'Customer',
  PRIVATE: 'Internal'
} as const

// eslint-disable-next-line no-redeclare
export type DiscussionType =
  typeof DiscussionType[keyof typeof DiscussionType];

export const Actions = {
  Complete: 'Complete',
  AddTeamMember: 'Add Team Member',
  DeleteTeamMember: 'Delete Team Member',
  FormSubmit: 'Form Submit',
  FormUpdate: 'Form Updated',
  AddDiscussion: 'Add Discussion',
  ReplyDiscussion: 'Reply Discussion',
  AddDocument: 'Add Document',
  DeleteDocument: 'Delete Document',
  FeedbackSubmit: 'Feedback Submit'
}
export const notifications = {
  Complete: true,
  AddTeamMember: true,
  DeleteTeamMember: true,
  FormSubmit: true,
  FormUpdate: true,
  AddDiscussion: true,
  ReplyDiscussion: true,
  AddDocument: true,
  DeleteDocument: true,
  FeedbackSubmit: true
}
export const STATUS_ENUM = {
  WaitingForDocument: 'Waiting For Documents',
  WaitingForPMValidation: 'Waiting For PM Validation',
  WaitingForQAQC: 'Waiting For QA/QC',
  WaitingForUnitHeadApproval: 'Waiting For Unit Head Approval',
  WaitingForDeputyDirectorReview: 'Waiting For Deputy Director Review',
  WaitingForFM_RMApproval: 'Waiting For FM/RM Approval',
  Submitted: 'Submitted',
  Completed: 'Completed',
  Saved: 'Saved',
  Copied: 'Copied'
} as const

export enum STATUS_CODE {
  SUBMITTED = 2,
  SAVED = 1,
  CANCELED = 3,
  WaitingforInternalReview = 4,
  WaitingforDSCAFunding = 5,
  Implemented = 6,
  Active = 7,
  Closed = 8
}

export enum STATUS_CODE_TRAINIG {
  SUBMITTED = 2,
  SAVED = 1,
  CANCELED = 3,
  seatValidation = 4,
  execution = 5,
  utiliZation = 6,
  Billing = 7,
  Reconciliation = 8,
  closure = 9
}
// eslint-disable-next-line no-redeclare
export type STATUS_ENUM =
  typeof STATUS_ENUM[keyof typeof STATUS_ENUM];
export const SELECT_LABEL = 'Select'
export const YES_NO_VALUES = ['Yes', 'No'] as const
export const YES_NO_VALUES_REVERSED = ['No', 'Yes'] as const

export const PHONE_VALIDATION = {
  MAX_LENGTH: 16,
  MIN_LENGTH: 1,
  ALLOWED_PATTERN: /^[\d ()+-]{1,16}$/,
  SEPARATORS_TO_REMOVE: ['-', '/'],
  ALLOWED_CHARACTERS: /[\d ()+-]/
} as const

export const USER_PROFILE_TABS: UserProfileSchema['tabs'] = [
  {
    id: 'profile',
    title: 'Profile',
    type: 'profile' as const,
    sections: [
      {
        id: 'personalDetails',
        title: 'Personal Details',
        fields: [
          {
            name: 'FirstName',
            label: 'First Name',
            type: 'text',
            required: true,
            placeholder: 'Enter first name',
            maxLength: 255,
            layoutColumn: 'mb-1 col-12 col-sm-6 col-lg-3 col-xxl-20per mt-2',
            info: 'First Name',
            tooltipPlacement: 'top'
          },
          {
            name: 'LastName',
            label: 'Last Name',
            type: 'text',
            required: true,
            placeholder: 'Enter last name',
            maxLength: 255,
            layoutColumn: 'mb-1 col-12 col-sm-6 col-lg-3 col-xxl-20per mt-2',
            info: 'Last Name',
            tooltipPlacement: 'top'
          },
          {
            name: 'PhoneNumber',
            label: 'Phone Number',
            type: 'tel',
            placeholder: 'Enter phone number',
            maxLength: 20,
            layoutColumn: 'mb-1 col-12 col-sm-6 col-lg-3 col-xxl-20per mt-2',
            info: 'Phone Number',
            tooltipPlacement: 'top'
          },
          {
            name: 'Email',
            label: 'Email',
            type: 'peoplepicker',
            required: true,
            placeholder: 'Search by name or email...',
            layoutColumn: 'mb-1 col-12 col-sm-6 col-lg-3 col-xxl-20per mt-2',
            info: 'Email',
            tooltipPlacement: 'top'
          }
        ]
      }
    ]
  },
  {
    id: 'userPreferences',
    title: 'User Preferences',
    type: 'notification' as const,
    sections: [
      {
        id: 'notificationSettings',
        title: 'Notification Settings',
        fields: [
          {
            name: 'userRole',
            label: 'User Role',
            type: 'select',
            info: 'User Role',
            tooltipPlacement: 'top',
            options: [
              { label: 'Admin', value: 'admin' },
              { label: 'Contributor', value: 'contributor' },
              { label: 'Viewer', value: 'viewer' }
            ],
            layoutColumn: 'mb-2 col-12 col-md-4'
          },
          { name: 'discussionAddCustomer', label: 'Discussion Add Customer', type: 'checkbox', info: 'Notify when a customer adds a discussion', tooltipPlacement: 'top', layoutColumn: 'mb-1 col-12 col-sm-6 col-lg-3 col-xxl-20per mt-2' },
          { name: 'discussionAddInternal', label: 'Discussion Add Internal', type: 'checkbox', info: 'Notify when an internal discussion is added', tooltipPlacement: 'top', layoutColumn: 'mb-1 col-12 col-sm-6 col-lg-3 col-xxl-20per mt-2' },
          { name: 'replyDiscussion', label: 'Reply Discussion', type: 'checkbox', info: 'Notify when a reply is posted to a discussion', tooltipPlacement: 'top', layoutColumn: 'mb-1 col-12 col-sm-6 col-lg-3 col-xxl-20per mt-2' },
          { name: 'documentAdd', label: 'Document Add', type: 'checkbox', info: 'Notify when a document is added', tooltipPlacement: 'top', layoutColumn: 'mb-1 col-12 col-sm-6 col-lg-3 col-xxl-20per mt-2' },
          { name: 'documentDelete', label: 'Document Delete', type: 'checkbox', info: 'Notify when a document is deleted', tooltipPlacement: 'top', layoutColumn: 'mb-1 col-12 col-sm-6 col-lg-3 col-xxl-20per mt-2' },
          { name: 'teamMemberAdd', label: 'Team Member Add', type: 'checkbox', info: 'Notify when a team member is added', tooltipPlacement: 'top', layoutColumn: 'mb-1 col-12 col-sm-6 col-lg-3 col-xxl-20per mt-2' },
          { name: 'teamMemberDelete', label: 'Team Member Delete', type: 'checkbox', info: 'Notify when a team member is removed', tooltipPlacement: 'top', layoutColumn: 'mb-1 col-12 col-sm-6 col-lg-3 col-xxl-20per mt-2' },
          { name: 'resolveInquiry', label: 'Resolve Requirement', type: 'checkbox', info: 'Notify when a requirement is resolved', tooltipPlacement: 'top', layoutColumn: 'mb-1 col-12 col-sm-6 col-lg-3 col-xxl-20per mt-2' },
          { name: 'cancelInquiry', label: 'Cancel Requirement', type: 'checkbox', info: 'Notify when a requirement is cancelled', tooltipPlacement: 'top', layoutColumn: 'mb-1 col-12 col-sm-6 col-lg-3 col-xxl-20per mt-2' },
          { name: 'formUpdate', label: 'Form Update', type: 'checkbox', info: 'Notify when a form is updated', tooltipPlacement: 'top', layoutColumn: 'mb-1 col-12 col-sm-6 col-lg-3 col-xxl-20per mt-2' }
        ]
      }
    ]
  }
]

export const buildUserProfileSchema = (isEdit: boolean, _isEditing: boolean): UserProfileSchema => ({
  layout: 'tabs',
  instructions: [
    'All fields marked \'*\' must be completed.',
    ...(!isEdit
      ? ['Use the Submit button to create your profile.']
      : ['Use the Update button to save your changes.'])
  ],
  actions: {
    bottom: true,
    buttons: [
      { type: 'submit', label: isEdit ? 'Update' : 'Submit', icon: 'icon-rb-save' },
      { type: 'cancel', label: 'Cancel', icon: 'icon-rb-close font-12' }
    ]
  },
  tabs: USER_PROFILE_TABS
})

export const TABLE_COLUMNS = [
  { key: 'Title', label: 'Title', sortOrder: 'Title', canSort: true },
  { key: 'ItemGUID', label: 'Id', sortOrder: 'ItemGUID', canSort: true },
  { key: 'StatusCode', label: 'Status Code', sortOrder: 'StatusCode', canSort: true },
  { key: 'PreviousStatusCode', label: 'Previous Status Code', sortOrder: 'PreviousStatusCode', canSort: true },
  { key: 'PreviousStatusTitle', label: 'Previous Status Title', sortOrder: 'PreviousStatusTitle', canSort: true },
  { key: 'ItemCreated', label: 'ItemCreated', sortOrder: 'ItemCreated', canSort: true },
  { key: 'ItemCreatedBy', label: 'Item Created By', sortOrder: 'ItemCreatedBy', canSort: true },
  { key: 'ItemModified', label: 'Item Modified', sortOrder: 'ItemModified', canSort: true },
  { key: 'ItemModifiedBy', label: 'Item Modified By', sortOrder: 'ItemModifiedBy', canSort: true },
  { key: 'Status', label: 'Status', sortOrder: 'Status', canSort: true }
]

export interface SelectOption {
  label: string
  value: string
}

export const routeTitles: Record<string, string> = {
  '/': 'Dashboard',
  '/createcase': 'Initialize Case',
  '/createtraining': 'Training Track',
  '/create-requirement': 'Create Requirement',
  '/list-view': 'Requirements',
  '/cases': 'Cases',
  '/trainings': 'Trainings',
  '/detail-view': 'Detail View',
  '/case-detail-view': 'Case Detail View',
  '/case-detail-inner-view': 'Case Detail Inner View',
  '/training-detail-view': 'Training Detail View',
  '/accessdenied': 'Access Denied',
  '/announcements': 'Announcements',
  '/eventcalendar': 'Event Calendar',
  '/knowledge-base': 'Knowledge Base',
  '/pii': 'PII',
  '/pmg': 'Policy Memos & Guidelines',
  '/points-of-contact': 'Points of Contact',
  '/qa': 'Q&A',
  '/quick-links': 'Quick Links',
  '/settings': 'Settings',
  '/site-feedback': 'Site Feedback',
  '/release-notes': 'Release Notes',
  '/profile': 'My Profile'
}

export const innerViewFields: InnerViewFieldConfig[] = [
  { id: 'title', valueKey: 'Title', type: 'text', order: 1 },
  { id: 'description', valueKey: 'Description', type: 'richtext', order: 2 },
  { id: 'attachments', valueKey: 'AttachmentFiles', type: 'attachments', order: 3 },
  {
    id: 'meta',
    valueKey: 'Meta',
    type: 'meta',
    order: 4,
    getValue: (item: any) => item.ItemModified
  }
]

export const searchFields = [
  { id: 'title', valueKey: 'Title' },
  { id: 'description', valueKey: 'Description' },
  { id: 'tags', valueKey: 'Tags' },
  {
    id: 'attachments',
    valueKey: 'AttachmentFiles',
    getValue: (item: any) => item.AttachmentFiles?.map((file: any) => file.FileName).join(' ')
  }
]

export const getTags = (item: any): string[] => {
  if (!item?.Tags) return []
  return item.Tags.split(',').map((tag: string) => tag.trim()).filter(Boolean)
}

export const knowledgeGraphInnerViewFields = [
  {
    id: 'primary',
    valueKey: 'Title',
    type: 'text',
    order: 1
  },
  {
    id: 'secondary',
    valueKey: 'Description',
    type: 'richtext',
    order: 2
  },
  {
    id: 'files',
    valueKey: 'AttachmentFiles',
    type: 'attachments',
    order: 3
  },
  {
    id: 'meta',
    type: 'meta',
    valueKey: 'meta',
    order: 4,
    getValue: (item: any) => ({
      postedBy: item?.ItemModifiedBy?.Title ?? item?.ItemModifiedBy,
      postedDate: item?.ItemModified,
      tags: item?.Tags
    })
  }
]
export const knowledgeGraphSearchFields = [
  {
    id: 'title',
    valueKey: 'Title'
  },
  {
    id: 'description',
    valueKey: 'Description'
  },
  {
    id: 'tags',
    valueKey: 'Tags'
  },
  {
    id: 'files',
    getValue: (item: any) =>
      item.AttachmentFiles?.map((f: any) => f.FileName).join(' ')
  },
  {
    id: 'meta',
    type: 'meta',
    order: 4,
    getValue: (item: any) => ({
      postedBy: item?.ItemModifiedBy?.Title ?? item?.ItemModifiedBy,
      postedDate: item?.ItemModified,
      tags: item?.Tags
    })
  }
]

export const feedbackFieldsConfig: SiteFeedbackFieldConfig[] = [
  {
    key: 'Subject',
    type: 'text',
    label: 'Subject',
    required: true,
    maxLength: 120,
    placeholder: 'Enter subject'
  },
  {
    key: 'FeedBackAbout',
    type: 'select',
    label: 'Feedback About',
    required: true,
    options: [
      'Homepage',
      'Announcements',
      'Knowledge Base',
      'Create Form'
    ]
  },
  {
    key: 'Message',
    type: 'textarea',
    label: 'Message',
    required: true,
    rows: 5,
    placeholder: 'Message'
  },
  {
    key: 'Attachments',
    type: 'file',
    label: 'Attachments',
    hint: 'Upload the files which are in the .xlsx, .xls, .doc, .docx, .ppt, .pptx, .txt, .pdf, .png, .jpg, .jpeg, .gif, .msg and special characters will not be used in the document names. Maximum size for file is 25 MB. Limit is up to 10 files per screen.',
    note: 'Screenshots need to be saved locally before uploading into system.'
  }
]

export const getPublicURL = () => {
  return window.location.hostname === 'localhost' ? '/' : '../SiteAssets/'
}

export const menuitems = [
  {
    id: 'dashboard',
    label: 'Dashboard',
    path: '/',
    iconClassName: 'icon-rb-dashboard'
  },
  {
    id: 'create-requirement',
    label: 'Create Requirement',
    path: '/create-requirement',
    iconClassName: 'icon-rb-create-form'
  },
  {
    id: 'list-view',
    label: 'Requirements',
    path: '/list-view',
    matchPaths: ['/list-view', '/detail-view'],
    iconClassName: 'icon-rb-requirements'
  },
  {
    id: 'announcements',
    label: 'Announcements',
    path: '/announcements',
    iconClassName: 'icon-rb-announcement-mic'
  },
  {
    id: 'calendar',
    label: 'Event Calendar',
    path: '/eventcalendar',
    iconClassName: 'icon-rb-calendar'
  },
  {
    id: 'knowledge-base',
    label: 'Knowledge Base',
    path: '/knowledge-base',
    iconClassName: 'icon-rb-book-open'
  },
  {
    id: 'pmg',
    label: 'Policy Memos & Guidelines',
    path: '/pmg',
    iconClassName: 'icon-rb-files-blank-fill'
  },
  {
    id: 'points-of-contact',
    label: 'Points Of Contact',
    path: '/points-of-contact',
    iconClassName: 'icon-rb-user-book'
  },
  {
    id: 'qa',
    label: 'Q&A',
    path: '/qa',
    iconClassName: 'icon-rb-question-thick'
  },
  {
    id: 'quick-links',
    label: 'Quick Links',
    path: '/quick-links',
    iconClassName: 'icon-rb-link-angle-thick',
    separater: 'separater'
  },
  {
    id: 'settings',
    label: 'Settings',
    path: '/settings',
    iconClassName: 'icon-rb-settings'
  },
  {
    id: 'site-feedback',
    label: 'Site Feedback',
    path: '/site-feedback',
    iconClassName: 'icon-rb-site-feedback'
  },
  {
    id: 'release-notes',
    label: 'Release Notes',
    path: '/release-notes',
    iconClassName: 'icon-rb-file-text-earmark'
  }
]

export type AnnouncementInnerViewItem = I_Announcement & {
  AttachmentFiles?: Array<{
    FileName: string
    ServerRelativeUrl: string
  }>
}

export const normalizeAnnouncementItem = (item: AnnouncementInnerViewItem): AnnouncementInnerViewItem => ({
  ...item,
  AttachmentFiles: item.AttachmentFiles ?? [],
  Tags: item.Tags ?? '',
  ItemModifiedBy: typeof item.ItemModifiedBy === 'string'
    ? { Title: item.ItemModifiedBy }
    : item.ItemModifiedBy ?? { Title: 'System' }
})
export const announcementDashboardFields: any[] = [
  {
    id: 'title',
    valueKey: 'Title',
    type: 'text'
  },
  {
    id: 'description',
    valueKey: 'Description',
    type: 'richtext',
    maxLines: 3
  },
  {
    id: 'modifiedBy',
    valueKey: 'ItemModifiedBy',
    type: 'meta',
    getValue: (item: any) => {
      const by = item?.ItemModifiedBy?.Title ?? item?.ItemModifiedBy
      return by ? `Posted by: ${by}` : ''
    }
  }
]

const formatDate = (value: string) => {
  const formattedDate = convertDate(value)
  return formattedDate ?? value
}

const renderAttachmentFiles = (files?: AttachmentFileItem[]) => {
  if (!files?.length) {
    return 'No attachments uploaded.'
  }

  return createElement(
    'div',
    { className: 'd-flex flex-column gap-2' },
    ...files
      .map(file => {
        const fileName = file.FileName || file.name
        if (!fileName) return null
        return createElement(
          'div',
          { key: fileName, className: 'd-flex align-items-center gap-2' },
          createElement('span', { className: `${DocumentIconNames(fileName)} font-16`, 'aria-hidden': 'true' }),
          createElement('span', null, fileName)
        )
      })
      .filter(Boolean)
  )
}
export const announcementsConfig: MetadataConfig = {
  entityName: 'Announcement',
  layout: 'accordion',
  list: {
    title: 'Announcements',
    subtitle: 'Announcements',
    fields: [
      { key: 'Title', label: 'Title', className: 'col' },
      { key: 'Modified', label: 'Modified', className: 'col-md-3' },
      { key: 'IsArchived', label: 'Is Archived', className: 'col-md-2' }
    ]
  },
  accordion: {
    sections: [
      { key: 'Description', label: 'Description',render: (item: AnnouncementItem) =>removehtmltags(item.Description ?? '')},
      { key: 'Tags', label: 'Tags' },
      { key: 'ExpiryDate', label: 'Expiry Date', render: (item: AnnouncementItem) => formatDate(item.ExpiryDate) },
      { key: 'AttachmentFiles', label: 'Attachments', render: (item: AnnouncementItem) => renderAttachmentFiles(item.AttachmentFiles) }
    ]
  },
  form: {
    fields: [
      {
        key: 'Title', type: 'text', label: 'Title', placeholder: 'Enter title',
        required: true, maxLength: 255, isInfo: true, info: 'Title', infoIcon: 'icon-rb-info',
        layoutcolumns: 'col-12', formclassName: 'form-vertical'
      },
      {
        key: 'Description', type: 'richtext', label: 'Description', placeholder: 'Enter description',
        required: true, isInfo: true, info: 'Description', infoIcon: 'icon-rb-info',
        layoutcolumns: 'col-12', formclassName: 'form-vertical'
      },
      {
        key: 'AttachmentFiles', type: 'file', label: 'Attachments',
        isInfo: true, info: 'Attach File(s)', infoIcon: 'icon-rb-info',
        layoutcolumns: 'col-12', formclassName: 'form-vertical',
        hint: 'Upload the files which are in the .png, .jpeg, .xlsx,.txt .docx, .pdf files and special characters will not be used in the document names. Maximum size for file is 25 MB. Limit is up to 10 files per screen.',
        note: 'Screenshots need to be saved locally before uploading into system.'
      },
      {
        key: 'Tags', type: 'text', label: 'Tags', placeholder: 'Enter tags',
        required: true, maxLength: 255, isInfo: true, info: 'Tags', infoIcon: 'icon-rb-info',
        layoutcolumns: 'col-12 col-lg-6', formclassName: 'form-vertical'
      },
      {
        key: 'ExpiryDate', type: 'date', label: 'Expiry Date',
        required: true, isInfo: true, info: 'Expiry Date', infoIcon: 'icon-rb-info',
        layoutcolumns: 'col-12 col-lg-6', formclassName: 'form-vertical'
      },
      {
        key: 'IsArchived', type: 'select', label: 'Is Archived', options: ['Yes', 'No'],
        visibleIn: 'edit', isInfo: true, info: 'Is Archived', infoIcon: 'icon-rb-info',
        layoutcolumns: 'col-12 col-lg-6', formclassName: 'form-vertical'
      }
    ]
  },
  buttons: {
    add: { label: 'Add', icon: 'icon-rb-add' },
    save: { label: 'Save', icon: 'icon-rb-save' },
    update: { label: 'Update', icon: 'icon-rb-arrow-repeat' },
    cancel: { label: 'Cancel', icon: 'icon-rb-close', variant: 'secondary' },
    edit: { label: 'Edit', icon: 'icon-rb-pencil', variant: 'secondary', size: 'sm' },
    delete: { label: 'Delete', icon: 'icon-rb-trashbin', variant: 'secondary', size: 'sm' }
  },
  messages: {
    confirmDelete: 'Are you sure you want to delete this announcement item?',
    noChange: 'No announcement changes detected',
  },
  alert: {
    confirm: { label: 'Yes', icon: 'icon-rb-checked' },
    cancel: { label: 'No', icon: 'icon-rb-close' }
  }

}

export const knowledgeGraphConfig: MetadataConfig = {
  entityName: 'Knowledge Base Item',
  layout: 'accordion',
  list: {
    title: 'Knowledge Base',
    subtitle: 'Knowledge Base',
    fields: [
      { key: 'Title', label: 'Title', className: 'col' },
      { key: 'Modified', label: 'Modified', className: 'col-md-3' },
      { key: 'IsArchived', label: 'Is Archived', className: 'col-md-2' }
    ]
  },
  accordion: {
    sections: [
      { key: 'Description', label: 'Description',render: (item: KnowledgeGraphItem) =>removehtmltags(item.Description ?? '')},
      { key: 'Tags', label: 'Tags' },
      { key: 'AttachmentFiles', label: 'Attachments', render: (item: KnowledgeGraphItem) => renderAttachmentFiles(item.AttachmentFiles) },
      { key: 'IsArchived', label: 'Is Archived', render: (item: KnowledgeGraphItem) => item.IsArchived ? 'Yes' : 'No' }
    ]
  },
  form: {
    fields: [
      {
        key: 'Title', type: 'text', label: 'Title', placeholder: 'Enter title',
        required: true, maxLength: 255, isInfo: true, info: 'Title', infoIcon: 'icon-rb-info',
        layoutcolumns: 'col-12', formclassName: 'form-vertical'
      },
      {
        key: 'Description', type: 'richtext', label: 'Description', placeholder: 'Enter description',
        required: true, isInfo: true, info: 'Description', infoIcon: 'icon-rb-info',
        layoutcolumns: 'col-12', formclassName: 'form-vertical'
      },
      {
        key: 'AttachmentFiles', type: 'file', label: 'Attachments',
        isInfo: true, info: 'Attach File(s)', infoIcon: 'icon-rb-info',
        layoutcolumns: 'col-12', formclassName: 'form-vertical',
        hint: 'Upload the files which are in the .png, .jpeg, .xlsx,.txt .docx, .pdf files and special characters will not be used in the document names. Maximum size for file is 25 MB. Limit is up to 10 files per screen.',
        note: 'Screenshots need to be saved locally before uploading into system.'
      },
      {
        key: 'Tags', type: 'text', label: 'Tags', placeholder: 'Enter tags',
        required: true, maxLength: 255, isInfo: true, info: 'Tags', infoIcon: 'icon-rb-info',
        layoutcolumns: 'col-12 col-lg-6', formclassName: 'form-vertical'
      },
      {
        key: 'IsArchived', type: 'select', label: 'Is Archived', options: ['Yes', 'No'],
        visibleIn: 'edit', isInfo: true, info: 'Is Archived', infoIcon: 'icon-rb-info',
        layoutcolumns: 'col-12 col-lg-6', formclassName: 'form-vertical'
      }
    ]
  },
  buttons: {
    add: { label: 'Add', icon: 'icon-rb-add' },
    save: { label: 'Save', icon: 'icon-rb-save' },
    update: { label: 'Update', icon: 'icon-rb-arrow-repeat' },
    cancel: { label: 'Cancel', icon: 'icon-rb-close', variant: 'secondary' },
    edit: { label: 'Edit', icon: 'icon-rb-pencil', variant: 'secondary', size: 'sm' },
    delete: { label: 'Delete', icon: 'icon-rb-trashbin', variant: 'secondary', size: 'sm' }
  },
  messages: {
    confirmDelete: 'Are you sure you want to delete this Knowledge Base item?',
    noChange: 'No Knowledge Base changes detected'
  },
  alert: {
    confirm: { label: 'Yes', icon: 'icon-rb-checked' },
    cancel: { label: 'No', icon: 'icon-rb-close' }
  }
}

export const qaConfig: MetadataConfig = {
  entityName: 'Q&A Item',
  layout: 'accordion',
  list: {
    title: 'Q&A',
    subtitle: 'Q&A',
    fields: [
      { key: 'Question', label: 'Question', className: 'col' },
      { key: 'Modified', label: 'Modified', className: 'col-md-3' },
      { key: 'IsArchived', label: 'Is Archived', className: 'col-md-2' }
    ]
  },
  accordion: {
    sections: [
      { key: 'Description', label: 'Description',render: (item: QaItem) =>removehtmltags(item.Description ?? '')},
      { key: 'Answer', label: 'Answer', render: (item: QaItem) => removehtmltags(item.Answer ?? '') },
      { key: 'Tags', label: 'Tags' },
      { key: 'AttachmentFiles', label: 'Attachments', render: (item: QaItem) => renderAttachmentFiles(item.AttachmentFiles) },
    ]
  },
  form: {
    fields: [
      {
        key: 'Question', type: 'text', label: 'Question', placeholder: 'Enter question',
        required: true, maxLength: 255, isInfo: true, info: 'Question', infoIcon: 'icon-rb-info',
        layoutcolumns: 'col-12', formclassName: 'form-vertical'
      },
      {
        key: 'Description', type: 'richtext', label: 'Description', placeholder: 'Enter description',
        required: true, isInfo: true, info: 'Description', infoIcon: 'icon-rb-info',
        layoutcolumns: 'col-12', formclassName: 'form-vertical'
      },
      {
        key: 'Answer', type: 'richtext', label: 'Answer', placeholder: 'Enter answer',
        required: true, isInfo: true, info: 'Answer', infoIcon: 'icon-rb-info',
        layoutcolumns: 'col-12', formclassName: 'form-vertical'
      },
      {
        key: 'AttachmentFiles', type: 'file', label: 'Attachments',
        isInfo: true, info: 'Attach File(s)', infoIcon: 'icon-rb-info',
        layoutcolumns: 'col-12', formclassName: 'form-vertical',
        hint: 'Upload the files which are in the .png, .jpeg, .xlsx,.txt .docx, .pdf files and special characters will not be used in the document names. Maximum size for file is 25 MB. Limit is up to 10 files per screen.',
        note: 'Screenshots need to be saved locally before uploading into system.'
      },
      {
        key: 'Tags', type: 'text', label: 'Tags', placeholder: 'Enter tags',
        required: true, maxLength: 255, isInfo: true, info: 'Tags', infoIcon: 'icon-rb-info',
        layoutcolumns: 'col-12 col-lg-6', formclassName: 'form-vertical'
      },
      {
        key: 'IsArchived', type: 'select', label: 'Is Archived', options: ['Yes', 'No'],
        visibleIn: 'edit', isInfo: true, info: 'Is Archived', infoIcon: 'icon-rb-info',
        layoutcolumns: 'col-12 col-lg-6', formclassName: 'form-vertical'
      }
    ]
  },
  buttons: {
    add: { label: 'Add', icon: 'icon-rb-add' },
    save: { label: 'Save', icon: 'icon-rb-save' },
    update: { label: 'Update', icon: 'icon-rb-arrow-repeat' },
    cancel: { label: 'Cancel', icon: 'icon-rb-close', variant: 'secondary' },
    edit: { label: 'Edit', icon: 'icon-rb-pencil', variant: 'secondary', size: 'sm' },
    delete: { label: 'Delete', icon: 'icon-rb-trashbin', variant: 'secondary', size: 'sm' }
  },
  messages: {
    confirmDelete: 'Are you sure you want to delete this Q&A item?',
    noChange: 'No Q&A changes detected'
  },
  alert: {
    confirm: { label: 'Yes', icon: 'icon-rb-checked' },
    cancel: { label: 'No', icon: 'icon-rb-close' }
  }
}

export const pointOfContactConfig: MetadataConfig = {
  entityName: 'Point of Contact',
  layout: 'accordion',
  list: {
    title: 'Points of Contact',
    subtitle: 'Points of Contact',
    fields: [
      { key: 'ContactName', label: 'Name', className: 'col', formatter: (val: any) => val?.DisplayText ?? val ?? '--' },
      { key: 'Modified', label: 'Modified', className: 'col-md-3' },
      { key: 'IsArchived', label: 'Is Archived', className: 'col-md-2' }
    ]
  },
  accordion: {
    sections: [
      { key: 'ContactEmail', label: 'Email' },
      { key: 'ContactPhone', label: 'Phone' }
    ]
  },
  form: {
    fields: [
      {
        key: 'ContactName', type: 'peoplepicker' as any, label: 'Point of Contact', placeholder: 'Enter name',
        required: true, maxLength: 255, isInfo: true, info: 'Point of Contact', infoIcon: 'icon-rb-info',
        layoutcolumns: 'col-12 col-lg-6', formclassName: 'form-vertical',
        onSearch: async (value: string) => {
          if (!value || value.trim().length < 3) return []
          const matches = [...(await rhybusWhoHttp().Picker(value))]
          return matches.map((result: any) => {
            const display = result.profileName ?? result.displayName ?? result.cn ?? result.persona ?? result.email ?? ''
            const userKey = result.rid ?? result.userId ?? result.edipi ?? result.upn ?? result.email ?? ''
            return {
              DisplayText: display,
              email: result.email ?? '',
              Key: userKey,
              rid: userKey,
              persona: display,
            }
          })
        },
      },
      {
        key: 'ContactPhone', type: 'phone' as any, label: 'Phone', placeholder: 'Enter phone',
        required: true, maxLength: 255, isInfo: true, info: 'Phone', infoIcon: 'icon-rb-info',
        layoutcolumns: 'col-12 col-lg-6', formclassName: 'form-vertical'
      },
      {
        key: 'IsArchived', type: 'select', label: 'Is Archived', options: ['Yes', 'No'],
        visibleIn: 'edit', isInfo: true, info: 'Is Archived', infoIcon: 'icon-rb-info',
        layoutcolumns: 'col-12 col-lg-6', formclassName: 'form-vertical'
      }
    ]
  },
  buttons: {
    add: { label: 'Add', icon: 'icon-rb-add' },
    save: { label: 'Save', icon: 'icon-rb-save' },
    update: { label: 'Update', icon: 'icon-rb-arrow-repeat' },
    cancel: { label: 'Cancel', icon: 'icon-rb-close', variant: 'secondary' },
    edit: { label: 'Edit', icon: 'icon-rb-pencil', variant: 'secondary', size: 'sm' },
    delete: { label: 'Delete', icon: 'icon-rb-trashbin', variant: 'secondary', size: 'sm' }
  },
  messages: {
    confirmDelete: 'Are you sure you want to delete this point of contact?',
    noChange: 'No point of contact changes detected'
  },
  alert: {
    confirm: { label: 'Yes', icon: 'icon-rb-checked' },
    cancel: { label: 'No', icon: 'icon-rb-close' }
  }
}

export const quickLinksConfig: MetadataConfig = {
  entityName: 'Quick Link',
  layout: 'accordion',
  list: {
    title: 'Quick Links',
    subtitle: 'Quick Links',
    fields: [
      { key: 'Title', label: 'Title', className: 'col' },
      { key: 'URL', label: 'URL', className: 'col' },
      { key: 'Modified', label: 'Modified', className: 'col-md-3' },
      { key: 'IsArchived', label: 'Is Archived', className: 'col-md-2' }
    ]
  },
  accordion: {
    sections: [
      { key: 'Info', label: 'Info',render: (item: QuickLinkItem) => removehtmltags(item.Info ?? '') },
      { key: 'URL', label: 'URL' }
    ]
  },
  form: {
    fields: [
      {
        key: 'Title', type: 'text', label: 'Title', placeholder: 'Enter title',
        required: true, maxLength: 255, isInfo: true, info: 'Title', infoIcon: 'icon-rb-info',
        layoutcolumns: 'col-12 col-lg-6', formclassName: 'form-vertical',
        checkDuplicate: true,
        validationMessages: {
          required: 'Please enter a Quick Link Title',
          duplicate: 'This Quick Link Title is already taken'
        }
      },
      {
        key: 'URL', type: 'url', label: 'URL', placeholder: 'Enter URL',
        required: true, maxLength: 255, isInfo: true, info: 'URL', infoIcon: 'icon-rb-info',
        layoutcolumns: 'col-12 col-lg-6', formclassName: 'form-vertical',
        checkDuplicate: true,
        validationMessages: {
          required: 'Please enter a Quick Link URL',
          duplicate: 'This Quick Link URL is already taken',
          url: 'URL must be a valid URL'
        }
      },
      {
        key: 'Info', type: 'richtext', label: 'Info', placeholder: 'Enter info',
        required: false, isInfo: true, info: 'Info', infoIcon: 'icon-rb-info',
        layoutcolumns: 'col-12', formclassName: 'form-vertical'
      },
      {
        key: 'IsArchived', type: 'select', label: 'Is Archived', options: ['Yes', 'No'],
        visibleIn: 'edit', isInfo: true, info: 'Is Archived', infoIcon: 'icon-rb-info',
        layoutcolumns: 'col-12 col-lg-6', formclassName: 'form-vertical'
      }
    ]
  },
  buttons: {
    add: { label: 'Add', icon: 'icon-rb-add' },
    save: { label: 'Save', icon: 'icon-rb-save' },
    update: { label: 'Update', icon: 'icon-rb-arrow-repeat' },
    cancel: { label: 'Cancel', icon: 'icon-rb-close', variant: 'secondary' },
    edit: { label: 'Edit', icon: 'icon-rb-pencil', variant: 'secondary', size: 'sm' },
    delete: { label: 'Delete', icon: 'icon-rb-trashbin', variant: 'secondary', size: 'sm' }
  },
  messages: {
    confirmDelete: 'Are you sure you want to delete this quick link?',
    noChange: 'No quick link changes detected'
  },
  alert: {
    confirm: { label: 'Yes', icon: 'icon-rb-checked' },
    cancel: { label: 'No', icon: 'icon-rb-close' }
  }
}

// ----------------------------------------------------------------
// TAB CONFIG
// ----------------------------------------------------------------

export const contentManagementTabs: Array<{ key: ContentManagementTabKey; title: string }> = [
  { key: 'announcements', title: 'Announcements' },
  { key: 'eventcalendar', title: 'Event Calendar' },
  { key: 'knowledge-base', title: 'Knowledge Base' },
  { key: 'qa', title: 'Q&A' },
  { key: 'point-of-contact', title: 'Points of Contact' },
  { key: 'Policy Memos & Guidelines', title: 'Policy Memos & Guidelines' },
  { key: 'quick-links', title: 'Quick Links' }
]

export const normalizeIsArchived = (value: any): boolean =>
  value === true || value === 1 || value === '1' ||
  (typeof value === 'string' && (value.toLowerCase() === 'yes' || value.toLowerCase() === 'true'))

export const getNextContentManagementId = <T extends { ID: number }>(items: T[]) => (
  items.length ? Math.max(...items.map(item => item.ID)) + 1 : 1
)
export type DetailProgressStep = {
  label: string
  statusType: string
  history: Array<{
    user: string
    dateTime: string
    statusLabel?: string
  }>
}
export const DETAIL_PROGRESS_TEMPLATE: DetailProgressStep[] = [
  { label: 'Initiated', statusType: '', history: [] },
  { label: 'Internal Review', statusType: '', history: [] },
  { label: 'DSCA Funding', statusType: '', history: [] },
  { label: 'Implemented', statusType: '', history: [] },
  { label: 'Active', statusType: '', history: [] },
  { label: 'Closed', statusType: '', history: [] }
]

export const DETAIL_PROGRESS_FLOW = [
  { code: '4', label: 'Internal Review' },
  { code: '5', label: 'DSCA Funding' },
  { code: '6', label: 'Implemented' },
  { code: '7', label: 'Active' },
  { code: '8', label: 'Closed' },
]

export const TRAINING_PROGRESS_TEMPLATE: DetailProgressStep[] = [
  { label: 'Submitted', statusType: '', history: [] },
  { label: 'Seat Validation', statusType: '', history: [] },
  { label: 'Execution', statusType: '', history: [] },
  { label: 'Utilization', statusType: '', history: [] },
  { label: 'Billing', statusType: '', history: [] },
  { label: 'Reconciliation', statusType: '', history: [] },
  { label: 'Closure', statusType: '', history: [] },
]

export const TRAINING_PROGRESS_FLOW = [
  { code: '4', label: 'Seat Validation' },
  { code: '5', label: 'Execution' },
  { code: '6', label: 'Utilization' },
  { code: '7', label: 'Billing' },
  { code: '8', label: 'Reconciliation' },
  { code: '9', label: 'Closure' },
]

export const commonDetailFields = [
  { label: 'Requirement Type', value: 'Operations Support' },
  { label: 'Priority', value: 'High' },
  { label: 'Fiscal Year', value: 'FY26' },
  { label: 'Status', value: 'Approval' },
  { label: 'Submitted By', value: 'Acquisition Program Office' },
  { label: 'Last Updated', value: 'Mar 17, 2026' },
]

export const summaryHeaderFields = [
  {
    label: 'Organization',
    value: 'USAFE',
  },
  {
    label: 'Estimated Cost',
    value: 'CONUS',
  },
  {
    label: 'Contact Name',
    value: 'Acquisition',
  },
  {
    label: 'Contact Email',
    value: 'Yes',
  },
  {
    label: 'Submitted Date',
    value: 'Mar 12, 2026',
  }
]

export const replyPopupConfig = [
  {
    id: 'comment',
    label: 'Comment',
    valueKey: 'Comment',
    type: 'textarea',
    required: true,
    order: 1,
    rows: 3,
    placeholder: 'Enter your comment',
  }
]

export const addDiscussionPopupConfig = [
  {
    id: 'commentType',
    label: 'Comment Type',
    valueKey: 'CommentType',
    type: 'radio',
    required: false,
    order: 0,
    options: [
      { label: 'Customer', value: 'Public' },
      { label: 'Internal', value: 'Private' },
    ],
    defaultValue: 'Public',
  },
  {
    id: 'subject',
    label: 'Subject',
    valueKey: 'Subject',
    type: 'text',
    required: true,
    order: 1,
    maxLength: 255,
    placeholder: 'Enter subject',
  },
  {
    id: 'documentName',
    label: 'Comment For',
    valueKey: 'DocumentName',
    type: 'select',
    required: false,
    order: 3,
    defaultValue: 'Select',
  },
  {
    id: 'comment',
    label: 'Comment',
    valueKey: 'Comment',
    type: 'textarea',
    required: true,
    order: 4,
    rows: 3,
    placeholder: 'Enter your comment',
  },
]

export const initialDiscussionSuggestions = [
  {
    DisplayText: 'Taylor Reed',
    email: 'taylor.reed@example.com',
    Key: 'taylor.reed@example.com',
    rid: 1,
    persona: 'Taylor Reed',
  },
  {
    DisplayText: 'Jordan Blake',
    email: 'jordan.blake@example.com',
    Key: 'jordan.blake@example.com',
    rid: 2,
    persona: 'Jordan Blake',
  },
]

export const checklistItems = [
  { label: 'Operational Requirements/Inventory', isMandatory: true },
  { label: 'Acquisition Strategy', isMandatory: true },
  { label: 'Acquisition Plan', isMandatory: true },
  { label: 'Market Research', isMandatory: true },
  { label: 'IGCE (Independent Cost Estimate)', isMandatory: true },
  { label: 'IGCE Supporting Quotes (Or GOVCC Invoice)', isMandatory: true },
  { label: 'Signature Routing Slip', isMandatory: true },
  { label: '7600 A', isMandatory: true },
  { label: '7600 B', isMandatory: true },
  { label: 'HHS -755 (GOVCC)', isMandatory: true },
  { label: 'PSC-59', isMandatory: true },
  { label: 'Other', isMandatory: true },
]

/*Form fields*/

// Fiscal year runs Oct 1 – Sep 30; the FY label is the calendar year in which September falls.
// e.g. Oct 2025–Sep 2026 = FY 2026
const _getCurrentFiscalYear = (): number => {
  const now = new Date()
  const year = now.getFullYear()
  return now.getMonth() + 1 >= 10 ? year + 1 : year
}

const _currentFY = _getCurrentFiscalYear()

export const FISCAL_OPTIONS: SelectOption[] = Array.from({ length: 6 }, (_, i) => {
  const fy = String(_currentFY + i)
  return { label: fy, value: fy }
})

// Default selection for new cases: always the next fiscal year
export const DEFAULT_FISCAL_YEAR_OPTION: SelectOption = { label: String(_currentFY + 1), value: String(_currentFY + 1) }

export const CATEGORY_OPTIONS: SelectOption[] = [
  { label: 'Category X', value: 'Category X' },
  { label: 'Category Y', value: 'Category Y' }
]

export const CTR_OPTIONS: SelectOption[] = [
  { label: 'CTR 1', value: 'CTR 1' },
  { label: 'CTR 2', value: 'CTR 2' }
]

export const CASE_TYPE_OPTIONS: SelectOption[] = [
  { label: 'Grants', value: 'Grants' },
  { label: 'Equipment', value: 'equipment' },
  { label: 'Training', value: 'training' },
  { label: 'Facilities', value: 'facilities' },
  { label: 'Policy', value: 'policy' }
]

export const ORGANIZATION_OPTIONS: SelectOption[] = [
  { label: 'USAFE', value: 'usafe' },
  { label: 'AFMC', value: 'afmc' },
  { label: 'ACC', value: 'acc' },
  { label: 'AETC', value: 'aetc' }
]

const vettedOptions = [
  { label: 'Yes', value: 'true' },
  { label: 'No', value: 'false' },
]

export const fields = [
  { key: 'fiscalYear', type: 'select', label: 'Fiscal Year', placeholder: 'Select', options: FISCAL_OPTIONS, isMandatory: true, tooltipPlacement: 'top', colClass: 'col-12 col-md-6 col-lg-3' },
  { key: 'country', type: 'select', label: 'Country', placeholder: 'Select', options: [], isMandatory: true, tooltipPlacement: 'top', colClass: 'col-12 col-md-6 col-lg-3' },
  { key: 'implementingAgency', type: 'select', label: 'Implementing Agency', placeholder: 'Select', options: [], isMandatory: true, tooltipPlacement: 'top', colClass: 'col-12 col-md-6 col-lg-3' },
  { key: 'programType', type: 'select', label: 'Program Type', placeholder: 'Select', options: [], isMandatory: true, tooltipPlacement: 'top', colClass: 'col-12 col-md-6 col-lg-3' },
  { key: 'ceilingUsd', type: 'currency', label: 'Ceiling (USD)', placeholder: '$0.00', isMandatory: true, tooltipPlacement: 'top', colClass: 'col-12 col-md-6 col-lg-3' },
  { key: 'reservedUsd', type: 'currency', label: 'Reserved (USD)', placeholder: '$0.00', isMandatory: true, tooltipPlacement: 'top', colClass: 'col-12 col-md-6 col-lg-3' },
  { key: 'consumedUsd', type: 'currency', label: 'Consumed (USD)', placeholder: '$0.00', isMandatory: true, tooltipPlacement: 'top', colClass: 'col-12 col-md-6 col-lg-3' },
  { key: 'releasedUsd', type: 'currency', label: 'Released (USD)', placeholder: '$0.00', isMandatory: true, tooltipPlacement: 'top', colClass: 'col-12 col-md-6 col-lg-3' },
  { key: 'remainingUsd', type: 'currency', label: 'Remaining (USD)', readOnly: true, placeholder: '$0.00', isMandatory: false, tooltipPlacement: 'top', colClass: 'col-12 col-md-6 col-lg-3' },
  { key: 'utilizationPercent', type: 'text', label: 'Utilization %', readOnly: true, placeholder: 'Enter Utilization %', isMandatory: false, tooltipPlacement: 'top', colClass: 'col-12 col-md-6 col-lg-3' },
  { key: 'description', type: 'textarea', label: 'Description', placeholder: 'Enter Description', rows: 4, isMandatory: false, tooltipPlacement: 'top', colClass: 'col-12' },
  { key: 'attachments', type: 'file', label: 'Attachments', isMandatory: false, tooltipPlacement: 'top', colClass: 'col-12' }
]

export const trainingfields = [
  { key: 'userCaseId', type: 'select', label: 'User Case ID', placeholder: 'Select', options: [], isMandatory: true, tooltipId: TT_TRAINING_USER_CASE_ID, tooltip: TOOLTIP_DEFAULTS[TT_TRAINING_USER_CASE_ID], tooltipPlacement: 'top', colClass: 'col-12 col-md-6 col-lg-3' },
  { key: 'line', type: 'select', label: 'Line', placeholder: 'Select', options: [], isMandatory: true, tooltipId: TT_TRAINING_LINE, tooltip: TOOLTIP_DEFAULTS[TT_TRAINING_LINE], tooltipPlacement: 'top', colClass: 'col-12 col-md-6 col-lg-3' },
  { key: 'type', type: 'select', label: 'Type', placeholder: 'Select', options: [], isMandatory: true, tooltipId: TT_TRAINING_TYPE, tooltip: TOOLTIP_DEFAULTS[TT_TRAINING_TYPE], tooltipPlacement: 'top', colClass: 'col-12 col-md-6 col-lg-3' },
  { key: 'wcn', type: 'select', label: 'WCN', placeholder: 'Select', options: [], isMandatory: true, tooltipId: TT_TRAINING_WCN, tooltip: TOOLTIP_DEFAULTS[TT_TRAINING_WCN], tooltipPlacement: 'top', colClass: 'col-12 col-md-6 col-lg-3' },
  { key: 'priority', type: 'select', label: 'Priority', placeholder: 'Select', options: [], isMandatory: true, tooltipId: TT_TRAINING_PRIORITY, tooltip: TOOLTIP_DEFAULTS[TT_TRAINING_PRIORITY], tooltipPlacement: 'top', colClass: 'col-12 col-md-6 col-lg-3' },
  { key: 'fiscalYear', type: 'select', label: 'Fiscal Year', placeholder: 'Select', options: FISCAL_OPTIONS, isMandatory: true, tooltipId: TT_TRAINING_FISCAL_YEAR, tooltip: TOOLTIP_DEFAULTS[TT_TRAINING_FISCAL_YEAR], tooltipPlacement: 'top', colClass: 'col-12 col-md-6 col-lg-3' },
  { key: 'quarter', type: 'select', label: 'Quarter', placeholder: 'Select', options: [], isMandatory: true, tooltipId: TT_TRAINING_QUARTER, tooltip: TOOLTIP_DEFAULTS[TT_TRAINING_QUARTER], tooltipPlacement: 'top', colClass: 'col-12 col-md-6 col-lg-3' },
  { key: 'rank', type: 'select', label: 'Rank', placeholder: 'Select', options: [], isMandatory: true, tooltipId: TT_TRAINING_RANK, tooltip: TOOLTIP_DEFAULTS[TT_TRAINING_RANK], tooltipPlacement: 'top', colClass: 'col-12 col-md-6 col-lg-3' },
  { key: 'tpc', type: 'text', label: 'TPC', placeholder: 'Enter TPC Name', isMandatory: true, tooltipId: TT_TRAINING_TPC, tooltip: TOOLTIP_DEFAULTS[TT_TRAINING_TPC], tooltipPlacement: 'top', colClass: 'col-12 col-md-6 col-lg-3' },
  { key: 'studentFirstName', type: 'text', label: 'Training Person First Name', placeholder: 'Enter Training Person First Name', isMandatory: false, tooltipId: TT_TRAINING_STUDENT_FIRST_NAME, tooltip: TOOLTIP_DEFAULTS[TT_TRAINING_STUDENT_FIRST_NAME], tooltipPlacement: 'top', colClass: 'col-12 col-md-6 col-lg-3' },
  { key: 'studentMiddleName', type: 'text', label: 'Training Person Middle Name', placeholder: 'Enter Training Person Middle Name', isMandatory: false, tooltipId: TT_TRAINING_STUDENT_MIDDLE_NAME, tooltip: TOOLTIP_DEFAULTS[TT_TRAINING_STUDENT_MIDDLE_NAME], tooltipPlacement: 'top', colClass: 'col-12 col-md-6 col-lg-3' },
  { key: 'studentLastName', type: 'text', label: 'Training Person Last Name', placeholder: 'Enter Training Person Last Name', isMandatory: false, tooltipId: TT_TRAINING_STUDENT_LAST_NAME, tooltip: TOOLTIP_DEFAULTS[TT_TRAINING_STUDENT_LAST_NAME], tooltipPlacement: 'top', colClass: 'col-12 col-md-6 col-lg-3' },
  { key: 'vetted', type: 'select', label: 'Vetted', placeholder: 'Select', options: vettedOptions, isMandatory: true, tooltipId: TT_TRAINING_VETTED, tooltip: TOOLTIP_DEFAULTS[TT_TRAINING_VETTED], tooltipPlacement: 'top', colClass: 'col-12 col-md-6 col-lg-3' },
]
export const trainingtrackfields = [
  { key: 'suffix', type: 'select', label: 'Suffix', placeholder: 'Select', options: [], isMandatory: true, tooltipId: TT_TRAINING_SUFFIX, tooltip: TOOLTIP_DEFAULTS[TT_TRAINING_SUFFIX], tooltipPlacement: 'top', colClass: 'col-12 col-md-6 col-lg-3' },
  { key: 'tmasl', type: 'text', label: 'T-MASL', placeholder: 'Enter T-MASL', isMandatory: true, tooltipId: TT_TRAINING_TMASL, tooltip: TOOLTIP_DEFAULTS[TT_TRAINING_TMASL], tooltipPlacement: 'top', colClass: 'col-12 col-md-6 col-lg-3' },
  { key: 'location', type: 'text', label: 'Location', placeholder: 'Enter Location', isMandatory: true, tooltipId: TT_TRAINING_LOCATION, tooltip: TOOLTIP_DEFAULTS[TT_TRAINING_LOCATION], tooltipPlacement: 'top', colClass: 'col-12 col-md-6 col-lg-3' },
  { key: 'exa', type: 'select', label: 'EXA', placeholder: 'Select', options: [], isMandatory: true, tooltipId: TT_TRAINING_EXA, tooltip: TOOLTIP_DEFAULTS[TT_TRAINING_EXA], tooltipPlacement: 'top', colClass: 'col-12 col-md-6 col-lg-3' },
  { key: 'priority', type: 'select', label: 'Priority', placeholder: 'Select', options: [], isMandatory: false, tooltipId: TT_TRAINING_PRIORITY, tooltip: TOOLTIP_DEFAULTS[TT_TRAINING_PRIORITY], tooltipPlacement: 'top', colClass: 'col-12 col-md-6 col-lg-3' },
  { key: 'reportDate', type: 'date', label: 'Report Date', placeholder: 'MM/DD/YYYY', isMandatory: false, tooltipId: TT_TRAINING_REPORT_DATE, tooltip: TOOLTIP_DEFAULTS[TT_TRAINING_REPORT_DATE], tooltipPlacement: 'top', colClass: 'col-12 col-md-6 col-lg-3' },
  { key: 'startDate', type: 'date', label: 'Start Date', placeholder: 'MM/DD/YYYY', isMandatory: false, tooltipId: TT_FORM_START_DATE, tooltip: TOOLTIP_DEFAULTS[TT_FORM_START_DATE], tooltipPlacement: 'top', colClass: 'col-12 col-md-6 col-lg-3' },
  { key: 'endDate', type: 'date', label: 'End Date', placeholder: 'MM/DD/YYYY', isMandatory: false, tooltipId: TT_TRAINING_END_DATE, tooltip: TOOLTIP_DEFAULTS[TT_TRAINING_END_DATE], tooltipPlacement: 'top', colClass: 'col-12 col-md-6 col-lg-3' },
  { key: 'duration', type: 'text', label: 'Duration', placeholder: 'Enter Duration', isMandatory: false, tooltipId: TT_TRAINING_DURATION, tooltip: TOOLTIP_DEFAULTS[TT_TRAINING_DURATION], tooltipPlacement: 'top', colClass: 'col-12 col-md-6 col-lg-3' },
  { key: 'durationType', type: 'select', label: 'Duration Type', placeholder: 'Select', options: [{ label: 'Days', value: 'Days' }, { label: 'Weeks', value: 'Weeks' }], isMandatory: false, tooltipId: TT_TRAINING_DURATION_TYPE, tooltip: TOOLTIP_DEFAULTS[TT_TRAINING_DURATION_TYPE], tooltipPlacement: 'top', colClass: 'col-12 col-md-6 col-lg-3' },
  { key: 'classId', type: 'text', label: 'Class ID', placeholder: 'Enter Class ID', isMandatory: true, tooltipId: TT_TRAINING_CLASS_ID, tooltip: TOOLTIP_DEFAULTS[TT_TRAINING_CLASS_ID], tooltipPlacement: 'top', colClass: 'col-12 col-md-6 col-lg-3' },
  { key: 'status', type: 'select', label: 'Status', placeholder: 'Select', options: [], isMandatory: false, tooltipId: TT_TRAINING_STATUS, tooltip: TOOLTIP_DEFAULTS[TT_TRAINING_STATUS], tooltipPlacement: 'top', colClass: 'col-12 col-md-6 col-lg-3' },
  { key: 'financialStatus', type: 'select', label: 'Financial Status', placeholder: 'Select', options: [], isMandatory: false, tooltipId: TT_TRAINING_FINANCIAL_STATUS, tooltip: TOOLTIP_DEFAULTS[TT_TRAINING_FINANCIAL_STATUS], tooltipPlacement: 'top', colClass: 'col-12 col-md-6 col-lg-3' },
  { key: 'facilityCategory', type: 'select', label: 'Facility Category', placeholder: 'Select', options: [], isMandatory: true, tooltipId: TT_TRAINING_FACILITY, tooltip: TOOLTIP_DEFAULTS[TT_TRAINING_FACILITY], tooltipPlacement: 'top', colClass: 'col-12 col-md-6 col-lg-3' },
  { key: 'button', type: 'button', label: 'Add', colClass: 'col-12 col-md-6 col-lg-3', isMandatory: false },
]
export const traininguploadfields = [
  { key: 'description', type: 'textarea', label: 'Description', placeholder: 'Enter Description', rows: 4, isMandatory: false, tooltipId: TT_TRAINING_DESCRIPTION, tooltip: TOOLTIP_DEFAULTS[TT_TRAINING_DESCRIPTION], tooltipPlacement: 'top', colClass: 'col-12' },
  { key: 'attachments', type: 'file', label: 'Attachments', isMandatory: false, tooltipId: TT_TRAINING_ATTACHMENTS, tooltipPlacement: 'top', colClass: 'col-12', isInfo: true, infoIcon: 'icon-rb-info' }
]

export const casefields = [
  { key: 'fiscalYear', type: 'select', label: 'Fiscal Year', placeholder: 'Select', options: FISCAL_OPTIONS, isMandatory: true, tooltipPlacement: 'top', colClass: 'col-12 col-md-6 col-lg-3' },
  { key: 'caseType', type: 'select', label: 'Case Type', placeholder: 'Select', options: CASE_TYPE_OPTIONS, isMandatory: true, tooltipPlacement: 'top', colClass: 'col-12 col-md-6 col-lg-3' },
  { key: 'country', type: 'select', label: 'Country', placeholder: 'Select', options: [], isMandatory: true, tooltipPlacement: 'top', colClass: 'col-12 col-md-6 col-lg-3' },
  { key: 'organization', type: 'select', label: 'Organization', placeholder: 'Select', options: ORGANIZATION_OPTIONS, isMandatory: true, tooltipPlacement: 'top', colClass: 'col-12 col-md-6 col-lg-3' },
  { key: 'fundingSource', type: 'text', label: 'Funding Source', placeholder: 'Enter Funding Source', isMandatory: true, tooltipPlacement: 'top', colClass: 'col-12 col-md-6 col-lg-3' },
  { key: 'title', type: 'text', label: 'Title', placeholder: 'Enter Title', isMandatory: true, tooltipPlacement: 'top', colClass: 'col-12 col-md-6' },
  { key: 'priority', type: 'select', label: 'Priority', placeholder: 'Select', options: [], isMandatory: false, tooltipPlacement: 'top', colClass: 'col-12 col-md-6 col-lg-3' },
  { key: 'pocName', type: 'text', label: 'POC Name', placeholder: 'Enter Name or Email address', isMandatory: false, tooltipPlacement: 'top', colClass: 'col-12 col-md-6 col-lg-3' },
  { key: 'pocEmail', type: 'text', label: 'POC Email', placeholder: 'Enter POC Email', isMandatory: false, tooltipPlacement: 'top', colClass: 'col-12 col-md-6 col-lg-3' },
  { key: 'pocPhoneNumber', type: 'text', label: 'POC Phone Number', placeholder: 'Enter POC Phone Number', isMandatory: false, tooltipPlacement: 'top', colClass: 'col-12 col-md-6 col-lg-3' },
]
export const casetrackfields = [
  { key: 'equipmentType', type: 'select', label: 'Equipment Type', placeholder: 'Select', options: [], isMandatory: true, tooltipPlacement: 'top', colClass: 'col-12 col-md-6 col-lg-3' },
  { key: 'quantity', type: 'text', label: 'Quantity', placeholder: 'Enter Quantity', isMandatory: true, tooltipPlacement: 'top', colClass: 'col-12 col-md-6 col-lg-3' },
  { key: 'specifications', type: 'text', label: 'Specifications', placeholder: 'Enter Specifications', isMandatory: false, tooltipPlacement: 'top', colClass: 'col-12 col-md-6 col-lg-3' },
  { key: 'requiredDeliveryDate', type: 'date', label: 'Required Delivery Date', placeholder: 'MM/DD/YYYY', isMandatory: true, tooltipPlacement: 'top', colClass: 'col-12 col-md-6 col-lg-3' },
  { key: 'button', type: 'button', label: 'Add', colClass: 'col-12 text-end', isMandatory: false },
]
export const caseuploadfields = [
  { key: 'description', type: 'textarea', label: 'Description', placeholder: 'Enter Description', rows: 4, isMandatory: false, tooltipPlacement: 'top', colClass: 'col-12' },
  { key: 'attachments', type: 'file', label: 'Attachments', isMandatory: false, tooltipPlacement: 'top', colClass: 'col-12' }
]

export const contractFields = [
  { key: 'requestedPop', type: 'checkbox', label: 'Requested PoP', tooltipId: TT_FORM_REQUESTED_POP, tooltip: TOOLTIP_DEFAULTS[TT_FORM_REQUESTED_POP], tooltipPlacement: 'top', colClass: 'col-12 col-md-6 col-lg-3 col-xxl-2' },
  { key: 'baseStartDate', type: 'date', label: 'Base Year Start Date', isMandatory: true, tooltipId: TT_FORM_BASE_START_DATE, tooltip: TOOLTIP_DEFAULTS[TT_FORM_BASE_START_DATE], tooltipPlacement: 'top', placeholder: 'MM/DD/YYYY', colClass: 'col-12 col-md-6 col-lg-4 col-xxl-3' },
  { key: 'baseEndDate', type: 'date', label: 'Base Year End Date', isMandatory: true, tooltipId: TT_FORM_BASE_END_DATE, tooltip: TOOLTIP_DEFAULTS[TT_FORM_BASE_END_DATE], tooltipPlacement: 'top', placeholder: 'MM/DD/YYYY', colClass: 'col-12 col-md-6 col-lg-4 col-xxl-3' },
  { key: 'baseCost', type: 'currency', label: 'Base Year Cost', isMandatory: true, tooltipId: TT_FORM_BASE_COST, tooltip: TOOLTIP_DEFAULTS[TT_FORM_BASE_COST], tooltipPlacement: 'top', placeholder: '$0.00', colClass: 'col-12 col-md-6 col-lg-4 col-xxl-3' }
]

export const sectionBFields = [
  { key: 'requestorPhoneNumber', type: 'text', label: 'Requestor Phone Number', placeholder: 'Enter Requestor Phone Number', isMandatory: false, tooltipId: TT_FORM_REQUESTOR_PHONE, tooltip: TOOLTIP_DEFAULTS[TT_FORM_REQUESTOR_PHONE], tooltipPlacement: 'top', colClass: 'col-12 col-md-3' },
  { key: 'pocName', type: 'people', label: 'POC Name', isMandatory: true, tooltipId: TT_FORM_POC_NAME, tooltip: TOOLTIP_DEFAULTS[TT_FORM_POC_NAME], placeholder: 'Enter Name or email address', tooltipPlacement: 'top', colClass: 'col-12 col-md-3' },
  { key: 'pocPhoneNumber', type: 'text', label: 'POC Phone Number', placeholder: 'Enter POC Phone Number', isMandatory: true, tooltipId: TT_FORM_POC_PHONE, tooltip: TOOLTIP_DEFAULTS[TT_FORM_POC_PHONE], tooltipPlacement: 'top', colClass: 'col-12 col-md-3' },
  { key: 'otherName', type: 'people', label: 'Other Name', isMandatory: true, tooltipId: TT_FORM_OTHER_NAME, tooltip: TOOLTIP_DEFAULTS[TT_FORM_OTHER_NAME], placeholder: 'Enter Name or email address', tooltipPlacement: 'top', colClass: 'col-12 col-md-3' },
  { key: 'otherRole', type: 'text', label: 'Other Role', placeholder: 'Enter Other Role', isMandatory: false, tooltipId: TT_FORM_OTHER_ROLE, tooltip: TOOLTIP_DEFAULTS[TT_FORM_OTHER_ROLE], tooltipPlacement: 'top', colClass: 'col-12 col-md-3' },
  { key: 'otherPhoneNumber', type: 'text', label: 'Other Phone Number', placeholder: 'Enter Other Phone Number', isMandatory: true, tooltipId: TT_FORM_OTHER_PHONE, tooltip: TOOLTIP_DEFAULTS[TT_FORM_OTHER_PHONE], tooltipPlacement: 'top', colClass: 'col-12 col-md-3' }
]

export const ctrSupportVisible = (v: any) => v.ctrSupportRequired === 'yes'
export const ctrFields = [
  { key: 'ctrSupportRequired', type: 'radio', label: 'Does the product require specific support by a contractor?', options: [{ label: 'Yes', value: 'yes' }, { label: 'No', value: 'no' }], isMandatory: false, tooltipId: TT_FORM_CTR_SUPPORT_REQUIRED, tooltip: TOOLTIP_DEFAULTS[TT_FORM_CTR_SUPPORT_REQUIRED], tooltipPlacement: 'top', colClass: 'col-12 col-md-6' },
  { key: 'ctrVendor', type: 'select', label: 'Identify Which CTR Vendor will Support the Request', placeholder: 'Select', options: CTR_OPTIONS, isMandatory: true, visibleWhen: ctrSupportVisible, tooltipId: TT_FORM_CTR_VENDOR, tooltip: TOOLTIP_DEFAULTS[TT_FORM_CTR_VENDOR], tooltipPlacement: 'top', colClass: 'col-12 col-md-6' },
  { key: 'support', type: 'textarea', label: 'Describe that support', placeholder: 'Describe that support', rows: 4, isMandatory: true, visibleWhen: ctrSupportVisible, tooltipId: TT_FORM_CTR_SUPPORT, tooltip: TOOLTIP_DEFAULTS[TT_FORM_CTR_SUPPORT], tooltipPlacement: 'top', colClass: 'col-12' },
]

export const sectionCFields = [
  { key: 'requirementDescription', type: 'textarea', label: 'Requirement Description', placeholder: 'Enter Requirement Description', rows: 4, isMandatory: true, tooltipId: TT_FORM_REQUIREMENT_DESCRIPTION, tooltip: TOOLTIP_DEFAULTS[TT_FORM_REQUIREMENT_DESCRIPTION], tooltipPlacement: 'top', colClass: 'col-12 col-md-6' },
  { key: 'impactStatement', type: 'textarea', label: 'Impact Statement', placeholder: 'Enter Impact Statement', rows: 4, isMandatory: true, tooltipId: TT_FORM_IMPACT_STATEMENT, tooltip: TOOLTIP_DEFAULTS[TT_FORM_IMPACT_STATEMENT], tooltipPlacement: 'top', colClass: 'col-12 col-md-6' },
  { key: 'levelOfUrgency', type: 'textarea', label: 'Level of Urgency', placeholder: 'Enter Level of Urgency', rows: 4, isMandatory: true, tooltipId: TT_FORM_LEVEL_OF_URGENCY, tooltip: TOOLTIP_DEFAULTS[TT_FORM_LEVEL_OF_URGENCY], tooltipPlacement: 'top', colClass: 'col-12 col-md-6' },
  { key: 'scopeOfWork', type: 'textarea', label: 'Scope of Work', placeholder: 'Enter Scope of Work', rows: 4, isMandatory: true, tooltipId: TT_FORM_SCOPE_OF_WORK, tooltip: TOOLTIP_DEFAULTS[TT_FORM_SCOPE_OF_WORK], tooltipPlacement: 'top', colClass: 'col-12 col-md-6' },
  { key: 'otherBranches', type: 'select', label: 'Other Branches Who Leverage the Tool', placeholder: 'Select', options: CTR_OPTIONS, isMandatory: true, tooltipId: TT_FORM_OTHER_BRANCHES, tooltip: TOOLTIP_DEFAULTS[TT_FORM_OTHER_BRANCHES], tooltipPlacement: 'top', colClass: 'col-12 col-md-4' },
]

export const soleSourceVisible = (v: any) => v.soleSourceRequired === 'yes'
export const soleSourceFields = [
  { key: 'soleSourceRequired', type: 'radio', label: 'Does the Request Require a Specific Vendor to Sell the Product to the Government? (Sole Source Justifications)', options: [{ label: 'Yes', value: 'yes' }, { label: 'No', value: 'no' }], isMandatory: false, tooltipId: TT_FORM_SOLE_SOURCE_REQUIRED, tooltip: TOOLTIP_DEFAULTS[TT_FORM_SOLE_SOURCE_REQUIRED], tooltipPlacement: 'top', colClass: 'col-12 col-md-6' },
  { key: 'requestedVendor', type: 'text', label: 'Requested Vendor', placeholder: 'Enter Requested Vendor', isMandatory: true, visibleWhen: soleSourceVisible, tooltipId: TT_FORM_REQUESTED_VENDOR, tooltip: TOOLTIP_DEFAULTS[TT_FORM_REQUESTED_VENDOR], tooltipPlacement: 'top', colClass: 'col-12 col-md-6' },
  { key: 'soleSourceJustification', type: 'textarea', label: 'Describe Why Sole Source', placeholder: 'Describe Why Sole Source', rows: 10, isMandatory: true, visibleWhen: soleSourceVisible, tooltipId: TT_FORM_SOLE_SOURCE_JUSTIFICATION, tooltip: TOOLTIP_DEFAULTS[TT_FORM_SOLE_SOURCE_JUSTIFICATION], tooltipPlacement: 'top', colClass: 'col-12 col-md-6' },
  { key: 'soleSourceAttachments', type: 'file', label: 'Justification Document', isMandatory: false, visibleWhen: soleSourceVisible, tooltipId: TT_FORM_JUSTIFICATION_DOCUMENT, tooltip: TOOLTIP_DEFAULTS[TT_FORM_JUSTIFICATION_DOCUMENT], tooltipPlacement: 'top', colClass: 'col-12 col-md-6' }
]

export const brandNameVisible = (v: any) => v.brandNameRequired === 'yes'
export const brandNameFields = [
  { key: 'brandNameRequired', type: 'radio', label: 'Does the Request Require a Specific Product be Procured ? (Brand Name Justifications)', options: [{ label: 'Yes', value: 'yes' }, { label: 'No', value: 'no' }], isMandatory: false, tooltipId: TT_FORM_BRAND_NAME_REQUIRED, tooltip: TOOLTIP_DEFAULTS[TT_FORM_BRAND_NAME_REQUIRED], tooltipPlacement: 'top', colClass: 'col-12 col-md-6' },
  { key: 'requestedVendor', type: 'text', label: 'Requested Product', placeholder: 'Enter Requested Product', isMandatory: true, visibleWhen: brandNameVisible, tooltipId: TT_FORM_REQUESTED_PRODUCT, tooltip: TOOLTIP_DEFAULTS[TT_FORM_REQUESTED_PRODUCT], tooltipPlacement: 'top', colClass: 'col-12 col-md-6' },
  { key: 'brandNameJustification', type: 'textarea', label: 'Describe Why Brand Name', placeholder: 'Describe Why Brand Name', rows: 10, isMandatory: true, visibleWhen: brandNameVisible, tooltipId: TT_FORM_BRAND_NAME_JUSTIFICATION, tooltip: TOOLTIP_DEFAULTS[TT_FORM_BRAND_NAME_JUSTIFICATION], tooltipPlacement: 'top', colClass: 'col-12 col-md-6' },
  { key: 'brandNameAttachments', type: 'file', label: 'Justification Document', isMandatory: false, visibleWhen: brandNameVisible, tooltipId: TT_FORM_JUSTIFICATION_DOCUMENT, tooltip: TOOLTIP_DEFAULTS[TT_FORM_JUSTIFICATION_DOCUMENT], tooltipPlacement: 'top', colClass: 'col-12 col-md-6' }
]

export const sectionDFields = [
  { key: 'acquisitionMethod', type: 'select', label: 'Acquisition Method', placeholder: 'Select', options: CTR_OPTIONS, isMandatory: true, tooltipId: TT_FORM_ACQUISITION_METHOD, tooltip: TOOLTIP_DEFAULTS[TT_FORM_ACQUISITION_METHOD], tooltipPlacement: 'top', colClass: 'col-12' },
  { key: 'ufmsTargetDate', type: 'date', label: 'UFMS Target Date', isMandatory: true, tooltipId: TT_FORM_UFMS_TARGET_DATE, tooltip: TOOLTIP_DEFAULTS[TT_FORM_UFMS_TARGET_DATE], tooltipPlacement: 'top', placeholder: 'MM/DD/YYYY', colClass: 'col-12' },
]

export const requisitionFields = [
  { key: 'requisitionNumber', type: 'text', label: 'Requisition Number', placeholder: 'Enter Requisition Number', isMandatory: false, tooltipId: TT_FORM_REQUISITION_NUMBER, tooltip: TOOLTIP_DEFAULTS[TT_FORM_REQUISITION_NUMBER], tooltipPlacement: 'top', colClass: 'col-12 col-md-6 mt-0' },
]

export const sectionEFields = [
  { key: 'budgetreference', type: 'select', label: 'Budget Reference', placeholder: 'Select', options: CTR_OPTIONS, isMandatory: false, tooltipId: TT_FORM_BUDGET_REFERENCE, tooltip: TOOLTIP_DEFAULTS[TT_FORM_BUDGET_REFERENCE], tooltipPlacement: 'top', colClass: 'col-12 col-md-6 col-lg-4 col-xl-3' },
  { key: 'investment', type: 'select', label: 'Investment', placeholder: 'Select', options: CTR_OPTIONS, isMandatory: false, tooltipId: TT_FORM_INVESTMENT, tooltip: TOOLTIP_DEFAULTS[TT_FORM_INVESTMENT], tooltipPlacement: 'top', colClass: 'col-12 col-md-6 col-lg-4 col-xl-3' },
  { key: 'contractSpecialist', type: 'text', label: 'Contract Specialist ', placeholder: 'Enter Contract Specialist ', isMandatory: false, tooltipId: TT_FORM_CONTRACT_SPECIALIST, tooltip: TOOLTIP_DEFAULTS[TT_FORM_CONTRACT_SPECIALIST], tooltipPlacement: 'top', colClass: 'col-12 col-md-6 col-lg-4 col-xl-3' },
  { key: 'awardVendor', type: 'select', label: 'Awarded Vendor', placeholder: 'Select', options: CTR_OPTIONS, isMandatory: false, tooltipId: TT_FORM_AWARD_VENDOR, tooltip: TOOLTIP_DEFAULTS[TT_FORM_AWARD_VENDOR], tooltipPlacement: 'top', colClass: 'col-12 col-md-6 col-lg-4 col-xl-3' },
  { key: 'contractstartdate', type: 'date', label: 'Contract Start Date', isMandatory: false, tooltipId: TT_FORM_CONTRACT_START_DATE, tooltip: TOOLTIP_DEFAULTS[TT_FORM_CONTRACT_START_DATE], tooltipPlacement: 'top', placeholder: 'MM/DD/YYYY', colClass: 'col-12 col-md-6 col-lg-4 col-xl-3' },
  { key: 'contractenddate', type: 'date', label: 'Contract End Date', isMandatory: false, tooltipId: TT_FORM_CONTRACT_END_DATE, tooltip: TOOLTIP_DEFAULTS[TT_FORM_CONTRACT_END_DATE], tooltipPlacement: 'top', placeholder: 'MM/DD/YYYY', colClass: 'col-12 col-md-6 col-lg-4 col-xl-3' },
  { key: 'hhsAwardNumber', type: 'text', label: 'HHS Award Number ', placeholder: 'Enter HHS Award Number ', isMandatory: false, tooltipId: TT_FORM_HHS_AWARD_NUMBER, tooltip: TOOLTIP_DEFAULTS[TT_FORM_HHS_AWARD_NUMBER], tooltipPlacement: 'top', colClass: 'col-12 col-md-6 col-lg-4 col-xl-3' },
  { key: 'objectClass', type: 'select', label: 'Object Class', placeholder: 'Select', options: CTR_OPTIONS, isMandatory: false, tooltipId: TT_FORM_OBJECT_CLASS, tooltip: TOOLTIP_DEFAULTS[TT_FORM_OBJECT_CLASS], tooltipPlacement: 'top', colClass: 'col-12 col-md-6 col-lg-4 col-xl-3' },
  { key: 'masterObjectClass', type: 'select', label: 'Master Object Class', placeholder: 'Select', options: CTR_OPTIONS, isMandatory: false, tooltipId: TT_FORM_MASTER_OBJECT_CLASS, tooltip: TOOLTIP_DEFAULTS[TT_FORM_MASTER_OBJECT_CLASS], tooltipPlacement: 'top', colClass: 'col-12 col-md-6 col-lg-4 col-xl-3' },
]

export const dashboardKpiData = KpisData.map(item => ({
  ...item,
  valuecolour: item.ColorCode
}))
export const TBM_COLORS = ['#4472C4', '#70AD47', '#FF8042', '#9B59B6', '#FFD700', '#00BCD4']
export const PHASE_COLORS = ['#4472C4', '#ED7D31', '#A5A5A5', '#FFC000', '#5B9BD5', '#70AD47']

export const kpiToStatus: Record<string, string> = {
  'Total Cases': 'All',
  'In Progress': 'In Progress',
  'Completed': 'Completed',
  'Average Cycle (Days)': 'Average Cycle Days',
}

// ─── Static base chart configs ────────────────────────────────────────────────

export const PRODUCT_BAR_BASE_CONFIG = {
  chartType: 'bar',
  dataKey: 'name',
  container_width: '100%',
  container_height: 300,
  fill: true,
  stroke: false,
  barSize: 18,
  margin: { top: 10, right: 12, bottom: 8, left: 10 },
  series: [{ dataKey: 'value', color: '#1565C0' }],
  cartesianGrid: { stroke: '#e0e0e0', vertical: false },
  xAxis: {
    axisLine: true,
    tickLine: true,
    height: 40,
    tickMargin: 4,
    interval: 0,
    tickFormatter: (value: string) => value.length > 6 ? value.substring(0, 6) + '…' : value,
  },
  yAxis: {
    axisLine: true,
    tickLine: true,
    allowDecimals: false,
    width: 70,
    label: { value: 'Requirements', angle: -90, position: 'insideLeft', style: { textAnchor: 'middle' } },
  },
  legend: { legend: false },
  tooltip: { disabled: false },
}

export const TBM_DONUT_BASE_CONFIG = {
  container_height: 240,
  chartType: 'donut',
  dataKey: 'value',
  nameKey: 'name',
  outerRadius: 95,
  innerRadius: 58,
  chart_element_cy: '42%',
  margin: { top: 10, right: 10, bottom: 20, left: 10 },
  isAnimationActive: false,
  tooltip: { cursor: false },
  legend: { legend: false },
}

export const BRANCH_BAR_BASE_CONFIG = {
  chartType: 'bar',
  dataKey: 'name',
  container_width: '100%',
  container_height: 300,
  fill: true,
  stroke: false,
  barSize: 18,
  margin: { top: 10, right: 12, bottom: 8, left: 10 },
  series: [{ dataKey: 'value', color: '#26A69A' }],
  cartesianGrid: { stroke: '#e0e0e0', vertical: false },
  xAxis: {
    axisLine: true,
    tickLine: true,
    height: 40,
    tickMargin: 4,
    interval: 0,
    tickFormatter: (value: string) => value.length > 6 ? value.substring(0, 6) + '…' : value,
  },
  yAxis: {
    axisLine: true,
    tickLine: true,
    allowDecimals: false,
    width: 70,
    label: { value: 'Requirements', angle: -90, position: 'insideLeft', style: { textAnchor: 'middle' } },
  },
  legend: { legend: false },
  tooltip: { disabled: false },
}

export const FUND_STATUS_PIE_BASE_CONFIG = {
  container_height: 200,
  chartType: 'pie',
  dataKey: 'value',
  nameKey: 'name',
  outerRadius: 80,
  minAngle: 10,
  isAnimationActive: false,
  tooltip: { cursor: false },
  legend: { legend: false },
}

export const PROCUREMENT_PHASE_PIE_BASE_CONFIG = {
  container_height: 200,
  chartType: 'pie',
  dataKey: 'value',
  nameKey: 'name',
  outerRadius: 80,
  minAngle: 10,
  isAnimationActive: false,
  tooltip: { cursor: false },
  legend: { legend: false },
}

export type FilterState = Record<string, { order: number, value: { label: string, value: string }[] }>

export type RequirementTabKey = 'all' | 'canceled' | 'saved'

export type RequirementItem = {
  ID: number
  ItemGuid: string
  requestID: string
  requirementTitle: string
  product: string
  tbm: string
  division: string
  branch: string
  cor: string
  fiscalYear: string
  requestedAmount: string
  revisedAmount: string
  fundedAmount: string
  unfundedAmount: string
  submittedDate: string
  status: string
  completed: string
  tabKey: RequirementTabKey
  lastAction: string
  createdById?: number
}

export type ListViewExportColumn = {
  tableName: string
  fieldName: string
  displayName: string
  IsSelected?: boolean
}

export type RequirementTableColumn = {
  key: string
  label: string
  canSort?: boolean
}

export type ListViewCopyTarget = {
  value: string
  label: string
}

export const REQUIREMENT_SELECTION_VALIDATION_MESSAGE = 'Please select the requirements to perform the action'
export const COPY_VALIDATION_MESSAGE = 'Please select only one item to copy'

export const requirementHeaders = [
  { key: 'requestID', label: 'ID', canSort: true },
  { key: 'requirementTitle', label: 'Title', canSort: true },
  { key: 'product', label: 'Product', canSort: true },
  { key: 'tbm', label: 'TBM', canSort: true },
  { key: 'branch', label: 'Branch', canSort: true },
  { key: 'cor', label: 'COR', canSort: true },
  { key: 'requestedAmount', label: 'Requested Amount', canSort: true },
  { key: 'revisedAmount', label: 'Revised Amount', canSort: true },
  { key: 'fundedAmount', label: 'Funded Amount', canSort: true },
  { key: 'unfundedAmount', label: 'Unfunded Amount', canSort: true },
  { key: 'submittedDate', label: 'Submitted Date', canSort: true },
  { key: 'status', label: 'Status', canSort: true }
]
export const listViewExportColumns: ListViewExportColumn[] = [
  { tableName: 'Cases', fieldName: 'userCaseId', displayName: 'User Case ID' },
  { tableName: 'Cases', fieldName: 'caseType', displayName: 'Case Type' },
  { tableName: 'Cases', fieldName: 'programtype', displayName: 'Program Type' },
  { tableName: 'Cases', fieldName: 'ia', displayName: 'IA' },
  { tableName: 'Cases', fieldName: 'country', displayName: 'Country' },
  { tableName: 'Cases', fieldName: 'status', displayName: 'Status' },
  { tableName: 'Cases', fieldName: 'submittedBy', displayName: 'Submitted By' },
  { tableName: 'Cases', fieldName: 'submitteddate', displayName: 'Submitted Date' }
]
export const defaultSelectedExportColumns = listViewExportColumns.slice(0, 6)
export const EXPORT_SOURCE_LISTVIEW = 'Listview'
export const TABLE_SOURCE_LISTVIEW = 'Tableview'
export const EXPORT_SOURCE_TRAINING = 'TrainingListview'
export const TABLE_SOURCE_TRAINING = 'TrainingTableview'

export const trainingExportColumns: ListViewExportColumn[] = [
  { tableName: 'Trainings', fieldName: 'trainingTrackId', displayName: 'Training Track ID' },
  { tableName: 'Trainings', fieldName: 'userCaseId', displayName: 'User Case ID' },
  { tableName: 'Trainings', fieldName: 'line', displayName: 'Line' },
  { tableName: 'Trainings', fieldName: 'type', displayName: 'Type' },
  { tableName: 'Trainings', fieldName: 'wcn', displayName: 'WCN' },
  { tableName: 'Trainings', fieldName: 'priority', displayName: 'Priority' },
  { tableName: 'Trainings', fieldName: 'status', displayName: 'Status' },
  { tableName: 'Trainings', fieldName: 'quarter', displayName: 'Quarter' },
  { tableName: 'Trainings', fieldName: 'rank', displayName: 'Rank' },
  { tableName: 'Trainings', fieldName: 'tpc', displayName: 'TPC' },
  { tableName: 'Trainings', fieldName: 'submittedDate', displayName: 'Submitted Date' }
]

export const defaultSelectedTrainingExportColumns = trainingExportColumns.slice(0, 7)

export const statusColorMap: Record<string, string> = {
  'Initiated': '22',
  'Waiting for Internal Review': '30',
  'Waiting for DSCA Funding': '3',
  'Waiting for Implemented': '4',
  'Waiting for Active': '5',
  'Waiting for Closure': '6',
  'Submitted': '11',
  'Waiting for Seat Validation': '18',
  'Waiting for Execution': '3',
  'Waiting for Utilization': '12',
  'Waiting for Billing': '13',
  'Waiting for Reconciliation': '14',
  'Closed': '25'
}
export const KPI_STATUS_LIST = [
  { id: 'WaitingForInternalReview', label: 'Waiting for Internal Review', color: '2' },
  { id: 'WaitingForDSCAFunding', label: 'Waiting for DSCA Funding', color: '3' },
  { id: 'implemented', label: 'Implemented', color: '4' },
]

export const TRAINING_KPI_STATUS_LIST = [
  { id: 'waitingForSeatValidation', label: 'Waiting for Seat Validation', color: '18' },
  { id: 'waitingForExecution', label: 'Waiting for Execution', color: '3' },
  { id: 'waitingForutilization', label: 'Waiting for Utilization', color: '12' },
  { id: 'waitingForbilling', label: 'Waiting for Billing', color: '13' },
  { id: 'waitingForreconciliation', label: 'Waiting for Reconciliation', color: '14' },
  { id: 'waitingForclosure', label: 'Waiting for Closure', color: '25' },
]

export const KPI_QAQC_BRANCHES = [
  { id: 'IMIT', label: 'IM/IT', color: '1' },
  { id: 'RM', label: 'RM', color: '2' },
  { id: 'DCSProcurement', label: 'DCS Procurement', color: '3' },
  { id: 'AgreementsReviewIAA', label: 'Agreements Review IAA', color: '4' },
  { id: 'Legal', label: 'Legal', color: '5' },
  { id: 'CMRA', label: 'CMRA', color: '6' },
  { id: 'SpaceUtilization', label: 'Space Utilization', color: '7' },
  { id: 'Manpower', label: 'Manpower', color: '8' },
  { id: 'ATOPSEC', label: 'AT/OPSEC', color: '9' }
]

// ============================================================
// METADATA CONFIGS — Branch / Division / Product / TBM / BuildVersion
// ============================================================

const makeCommonMetadataConfig = (entityName: string, fieldLabel: string): MetadataConfig => ({
  entityName,
  layout: 'normal',
  list: {
    title: entityName,
    subtitle: `Add ${entityName}`,
    fields: [
      { key: 'MetadataValue', label: entityName, className: 'col' },
      { key: 'Modified', label: 'Modified', className: 'col-md-4' },
      { key: 'IsArchived', label: 'Is Archived', className: 'col-md-2' },
    ],
    noResultText: `No ${entityName} metadata available.`,
  },
  form: {
    fields: [
      {
        key: 'MetadataValue',
        type: 'text',
        label: fieldLabel,
        placeholder: `Enter ${fieldLabel}`,
        required: true,
        layoutcolumns: 'col-12 col-lg-12',
        formclassName: 'form-vertical',
        isInfo: true,
        info: fieldLabel,
        infoIcon: 'icon-rb-info',
      },
      {
        key: 'IsArchived',
        type: 'select' as any,
        label: 'Is Archived',
        options: ['Yes', 'No'],
        visibleIn: 'edit' as any,
        layoutcolumns: 'col-12 col-lg-6',
        formclassName: 'form-vertical',
        isInfo: true,
        info: 'Is Archived',
        infoIcon: 'icon-rb-info',
      },
    ],
  },
  buttons: {
    add: { label: 'Add', icon: 'icon-rb-add' },
    save: { label: 'Save', icon: 'icon-rb-save' },
    edit: { label: 'Edit', icon: 'icon-rb-pencil', variant: 'secondary', size: 'sm' },
    update: { label: 'Update', icon: 'icon-rb-arrow-repeat' },
    delete: { label: 'Delete', icon: 'icon-rb-trashbin', variant: 'secondary', size: 'sm' },
    cancel: { label: 'Cancel', icon: 'icon-rb-close', variant: 'secondary' },
  },
  messages: {
    noChange: `No ${entityName} changes detected`,
    confirmDelete: `Are you sure you want to delete this ${entityName} item?`,
    empty: `No ${entityName} metadata available.`,
  },
})

export const countryConfig = makeCommonMetadataConfig('Country', 'Country')
export const exaConfig = makeCommonMetadataConfig('EXA', 'EXA')
export const facilityCategoryConfig = makeCommonMetadataConfig('Facility Category', 'Facility Category')
export const implementingAgencyConfig = makeCommonMetadataConfig('Implementing Agency', 'Implementing Agency')
export const locationConfig = makeCommonMetadataConfig('Location', 'Location')
export const priorityConfig = makeCommonMetadataConfig('Priority', 'Priority')
export const programTypeConfig = makeCommonMetadataConfig('Program Type', 'Program Type')
export const rankConfig = makeCommonMetadataConfig('Rank', 'Rank')
export const trainingTypeConfig = makeCommonMetadataConfig('Training Type', 'Training Type')
export const branchConfig = countryConfig
export const divisionConfig = exaConfig
export const productConfig = facilityCategoryConfig
export const tbmConfig = implementingAgencyConfig
export const buildVersionConfig = makeCommonMetadataConfig('Update Build Version', 'Build Version')

// ============================================================
// TOOLTIP CONFIG
// ============================================================

export const tooltipMetadataConfig: MetadataConfig = {
  entityName: 'Tooltip',
  layout: 'accordion',
  list: {
    title: 'Tooltips',
    subtitle: 'Tooltips',
    fields: [
      { key: 'ToolTipID', label: 'Tooltip ID', className: 'col' },
      { key: 'LabelName', label: 'Tooltip Label', className: 'col-md-3' },
      { key: 'Modified', label: 'Modified', className: 'col-md-2' },
    ],
    noResultText: 'No tooltip metadata is available.',
  },
  accordion: {
    sections: [
      { key: 'TooltipDescription', label: 'Tooltip Description' },
    ],
  },
  form: {
    fields: [
      {
        key: 'ToolTipID', type: 'text', label: 'Tooltip ID',
        readOnly: true, visibleIn: 'edit',
        layoutcolumns: 'col-12 col-lg-6', formclassName: 'form-vertical',
        isInfo: true, info: 'Tooltip ID', infoIcon: 'icon-rb-info',
      },
      {
        key: 'LabelName', type: 'text', label: 'Tooltip Label',
        readOnly: true, visibleIn: 'edit',
        layoutcolumns: 'col-12 col-lg-6', formclassName: 'form-vertical',
        isInfo: true, info: 'Tooltip Label', infoIcon: 'icon-rb-info',
      },
      {
        key: 'TooltipDescription', type: 'textarea', label: 'Tooltip Description',
        placeholder: 'Update tooltip description', required: true, maxLength: 2000,
        layoutcolumns: 'col-12', formclassName: 'form-vertical',
        isInfo: true, info: 'Tooltip Description', infoIcon: 'icon-rb-info',
      },
    ],
  },
  buttons: {
    edit: { label: 'Edit', icon: 'icon-rb-pencil', variant: 'secondary', size: 'sm' },
    update: { label: 'Update', icon: 'icon-rb-arrow-repeat' },
    cancel: { label: 'Cancel', icon: 'icon-rb-close', variant: 'secondary' },
  },
  messages: {
    noChange: 'No tooltip description changes detected',
    empty: 'No tooltip metadata is available.',
  },
}

export const pocSearchFields = [
  { valueKey: 'ContactName' },
  { valueKey: 'ContactTitle' },
  { valueKey: 'ContactEmail' },
  { valueKey: 'ContactPhone' }
]

export const pocPageConfig = {
  pageTitle: 'Points of Contact',
  searchPlaceholder: 'Search Points of Contact'
}
export const qnaInnerViewFields: InnerViewFieldConfig[] = [
  {
    id: 'title',
    valueKey: 'Title',
    type: 'text',
    order: 1
  },
  {
    id: 'description',
    valueKey: 'Description',
    type: 'richtext',
    order: 2
  },
  {
    id: 'answer',
    valueKey: 'Answer',
    type: 'richtext',
    order: 3
  },
  {
    id: 'attachments',
    valueKey: 'AttachmentFiles',
    type: 'attachments',
    order: 4
  },
  {
    id: 'meta',
    valueKey: 'Meta',
    type: 'meta',
    order: 5,
    getValue: (item: any) => ({
      user: item?.ItemModifiedBy?.Title ?? item?.ItemModifiedBy ?? " ",
      date: item?.ItemModified ?? '',
      tags: item?.Tags ?? ''
    })
  }
]

export const qnaSearchFields = [
  { valueKey: 'Title' },
  { valueKey: 'Question' },
  { valueKey: 'Answer' },
  { valueKey: 'Description' }
]

export const qnaDashboardFields: any[] = [
  {
    id: 'question',
    valueKey: 'Question',
    type: 'text'
  },
  {
    id: 'answer',
    valueKey: 'Answer',
    type: 'richtext',
    maxLines: 3
  },
  {
    id: 'tags',
    valueKey: 'Tags',
    type: 'text'
  },
  {
    id: 'meta',
    valueKey: 'Meta',
    type: 'meta',
    getValue: (item: any) => {
      const by = item?.ItemModifiedBy?.Title ?? item?.ItemModifiedBy ?? " "
      return by ? `Posted by: ${by}` : ''
    }
  }
]

export const getQnaTags = (item: any) => {
  return item?.Tags ? item.Tags.split(',').map((tag: string) => tag.trim()).filter(Boolean) : []
}

export const qnaPageConfig = {
  pageTitle: 'Q&A',
  searchPlaceholder: 'Search Q&A'
}

export const qnaDashboardConfig = {
  title: 'Q&A',
  viewAllLabel: 'View All',
  viewAllUrl: '/qa',
  maxItems: 3,
  cardSize: 'lg' as const
}
export const quickLinksPageConfig = {
  pageTitle: 'Quick Links',
  searchPlaceholder: 'Search quick links',
  columnToHighlight: 'Title'
}

export const quickLinksDashboardConfig = {
  title: 'Quick Links',
  viewAllLabel: 'View All',
  viewAllUrl: '/quicklinks',
  maxItems: 5,
  cardSize: 'sm' as const
}
export const quickLinksSearchFields = [
  { valueKey: 'Title' }
]
const renderRichText = (value: string) => {
  const normalizedValue = value ? removeEmptyTags(value) : ''
  return normalizedValue
    ? createElement('div', { dangerouslySetInnerHTML: { __html: normalizedValue } })
    : 'No content provided.'
}

export const releaseNotesConfig: MetadataConfig = {
  entityName: 'Release Note',
  layout: 'accordion',
  list: {
    title: 'Release Notes',
    subtitle: 'Release Notes',
    fields: [
      { key: 'VersionName', label: 'Version Name', className: 'col' },
      {
        key: 'ReleaseDate',
        label: 'Date',
        className: 'col-md-2',
      },
      {
        key: 'Modified',
        label: 'Modified',
        className: ' min-w-md-200 max-w-md-200 '
      },
      {
        key: 'IsArchived',
        label: 'Is Archived',
        className: 'min-w-md-80 max-w-md-80',
      }
    ],
    noResultText: 'No release notes are available.'
  },
  accordion: {
    sections: [
      { key: 'NewFeatures', label: 'New Features', render: (item: ReleaseNoteItem) => renderRichText(item.NewFeatures) },
      { key: 'ResolvedIssues', label: 'Resolved Issues', render: (item: ReleaseNoteItem) => renderRichText(item.ResolvedIssues) },
      { key: 'KnownIssues', label: 'Known Issues', render: (item: ReleaseNoteItem) => renderRichText(item.KnownIssues) }
    ]
  },
  form: {
    fields: [
      {
        key: 'VersionName',
        type: 'text',
        label: 'Version Name',
        placeholder: 'Enter version name',
        required: true,
        maxLength: 255,
        isInfo: true,
        info: 'Version Name',
        infoIcon: 'icon-rb-info',
        layoutcolumns: 'col-12 col-lg-6',
        formclassName: 'form-vertical'
      },
      {
        key: 'ReleaseDate',
        type: 'date',
        label: 'Date',
        required: true,
        isInfo: true,
        info: 'Release Date',
        infoIcon: 'icon-rb-info',
        layoutcolumns: 'col-12 col-lg-6',
        formclassName: 'form-vertical'
      },
      {
        key: 'NewFeatures',
        type: 'richtext',
        label: 'New Features',
        placeholder: 'Enter new features',
        required: true,
        isInfo: true,
        info: 'New Features',
        infoIcon: 'icon-rb-info',
        layoutcolumns: 'col-12',
        formclassName: 'form-vertical'
      },
      {
        key: 'ResolvedIssues',
        type: 'richtext',
        label: 'Resolved Issues',
        placeholder: 'Enter resolved issues',
        required: true,
        isInfo: true,
        info: 'Resolved Issues',
        infoIcon: 'icon-rb-info',
        layoutcolumns: 'col-12',
        formclassName: 'form-vertical'
      },
      {
        key: 'KnownIssues',
        type: 'richtext',
        label: 'Known Issues',
        placeholder: 'Enter known issues',
        required: true,
        isInfo: true,
        info: 'Known Issues',
        infoIcon: 'icon-rb-info',
        layoutcolumns: 'col-12',
        formclassName: 'form-vertical'
      },
      {
        key: 'IsArchived',
        type: 'select',
        label: 'Is Archived',
        options: ['Yes', 'No'],
        visibleIn: 'edit',
        isInfo: true,
        info: 'Is Archived',
        infoIcon: 'icon-rb-info',
        layoutcolumns: 'col-6',
        formclassName: 'form-vertical'
      }
    ]
  },
  buttons: {
    add: { label: 'Add', icon: 'icon-rb-add' },
    save: { label: 'Save', icon: 'icon-rb-save' },
    update: { label: 'Update', icon: 'icon-rb-arrow-repeat' },
    cancel: { label: 'Cancel', icon: 'icon-rb-close', variant: 'secondary' },
    edit: { label: 'Edit', icon: 'icon-rb-pencil', variant: 'secondary', size: 'sm' },
    delete: { label: 'Delete', icon: 'icon-rb-trashbin', variant: 'secondary', size: 'sm' }
  },
  messages: {
    confirmDelete: 'Are you sure you want to delete this release note?',
    noChange: 'No release note changes detected',
    empty: 'No release notes are available.'
  }
}

export const releaseNotesInnerViewConfig = [
  {
    id: 'release-date',
    label: 'Release Date',
    valueKey: 'ReleaseDate',
    type: 'date',
    order: 1
  },
  {
    id: 'new-features',
    label: 'New Features',
    valueKey: 'NewFeatures',
    type: 'text',
    order: 2
  },
  {
    id: 'resolved-issues',
    label: 'Resolved Issues',
    valueKey: 'ResolvedIssues',
    type: 'text',
    order: 3
  },
  {
    id: 'known-issues',
    label: 'Known Issues',
    valueKey: 'KnownIssues',
    type: 'text',
    order: 4
  }
]
export const feedbackcolumns = [
  {
    key: 'Subject',
    label: 'Subject',
    type: 'text'
  },
  {
    key: 'FeedBackAbout',
    label: 'Feedback About',
    type: 'select'
  },
  {
    key: 'Message',
    label: 'Message',
    type: 'textarea'
  },
  {
    key: 'Attachments',
    label: 'Attachments',
    type: 'attachments',
    render: (item: any) => (
      item?.AttachmentFiles?.map((file: any) => {
        const fileName = file.FileName || file.Name
        const handleBlobDownload = (e: any) => {
          e.preventDefault()
          import('../services/detailview').then(m =>
            m.getDetailFileContent(item.eKey ?? item.ID, { Name: fileName }, 'sitefeedback')
              .then(content => {
                const blob = new Blob([content])
                const url = window.URL.createObjectURL(blob)
                const a = document.createElement('a')
                a.href = url
                a.download = fileName
                document.body.appendChild(a)
                a.click()
                a.remove()
                window.URL.revokeObjectURL(url)
              })
          )
        }
        return React.createElement('div', { key: fileName, className: 'd-flex align-items-center' },
          React.createElement('span', { className: `${DocumentIconNames(fileName)} pe-1` }),
          file.ServerRelativeUrl
            ? React.createElement('a', { href: file.ServerRelativeUrl, className: 'text-decoration-underline cursor', download: true }, fileName)
            : React.createElement('a', { href: '#', className: 'text-decoration-underline cursor', onClick: handleBlobDownload }, fileName)
        )
      })
    )
  },
  {
    key: 'Modified',
    label: 'Modified',
    type: 'date',
    render: (item: any) => `${item.ItemModifiedBy?.Title ?? item.ItemModifiedBy ?? ''} | ${convertDate(item.ItemModified, 'date')}`
  }
]
export const actions = [
  {
    label: 'Download Site Feedback',
    icon: 'icon-rb-arrow-line-download-thick me-1',
    className:
      'btn-sm btn-primary ms-auto whitetext text-nowrap border-radius-0 uppercase',
    onClick: (items: any[]) => import('../services/siteFeedback').then(m => m.downloadSiteFeedback(items)),
    showWhen: (feedbackitems: any[]) => feedbackitems.length > 0
  }
]
export const userAccessGroups = [
  'Administrators',
  'Contributors',
  'Readers'
]

export const userManagementConfig: UserManagementConfig = {
  addPopup: {
    showCurrentRoles: true,
    showAvailableRoles: true,
    showRemoveButton: true,
    searchUserLabel: 'Search User',
    currentRolesLabel: 'Current User Roles',
    availableRolesLabel: 'Available Roles',
    addButtonLabel: 'Add',
    cancelButtonLabel: 'Cancel'
  },
  table: {
    columns: {
      Title: 'Name',
      Email: 'Email'
    },
    showDeleteButton: true,
    showAccordion: false
  }
}

export const createUserInfoFromPerson = (person: PersonData, fallbackId: number): UserInfo => ({
  Id: fallbackId,
  Title: person.DisplayText,
  Email: person.email,
  LoginName: person.spKey ?? person.email
})
export const DELETE_USER = 'Are you sure, you want to delete the user?'
export const VALIDATION_MSG = 'You should not have permissions to delete users from this group'

export const grantSampleData = [
  {
    requestID: '000001',
    caseType: 'Grants',
    country: 'BA',
    ia: 'B',
    programtype: 'Aviation Leadership Program (ALP)',
    submitteddate: '03/29/2026',
    status: 'Waiting for Internal Review',
    ItemGUID: '000001'
  },
  {
    requestID: '000002',
    caseType: 'Grants',
    country: 'BA',
    ia: 'B',
    programtype: 'Aviation Leadership Program (ALP)',
    submitteddate: '03/29/2026',
    status: 'Waiting for Internal Review',
    ItemGUID: '000002'
  },
  {
    requestID: '000003',
    caseType: 'Grants',
    country: 'BA',
    ia: 'B',
    programtype: 'Aviation Leadership Program (ALP)',
    submitteddate: '03/29/2026',
    status: 'Waiting for Internal Review',
    ItemGUID: '000003'
  },
  {
    requestID: '000004',
    caseType: 'Grants',
    country: 'BA',
    ia: 'B',
    programtype: 'Aviation Leadership Program (ALP)',
    submitteddate: '03/29/2026',
    status: 'Waiting for Internal Review',
    ItemGUID: '000004'
  },
  {
    requestID: '000005',
    caseType: 'Grants',
    country: 'BA',
    ia: 'B',
    programtype: 'Aviation Leadership Program (ALP)',
    submitteddate: '03/29/2026',
    status: 'Waiting for Internal Review',
    ItemGUID: '000005'
  },
  {
    requestID: '000006',
    caseType: 'Grants',
    country: 'BA',
    ia: 'B',
    programtype: 'Aviation Leadership Program (ALP)',
    submitteddate: '03/29/2026',
    status: 'Waiting for Internal Review',
    ItemGUID: '000006'
  },
  {
    requestID: '000007',
    caseType: 'Grants',
    country: 'BA',
    ia: 'B',
    programtype: 'Aviation Leadership Program (ALP)',
    submitteddate: '03/29/2026',
    status: 'Waiting for Internal Review',
    ItemGUID: '000007'
  }
]

export const GRANT_TABLE_COLUMNS = [
  { key: 'userCaseId', label: 'User Case ID', sortOrder: 'userCaseId', canSort: true },
  { key: 'caseType', label: 'Case Type', sortOrder: 'caseType', canSort: true },
  { key: 'programtype', label: 'Program Type', sortOrder: 'programtype', canSort: true },
  { key: 'ia', label: 'IA', sortOrder: 'ia', canSort: true },
  { key: 'country', label: 'Country', sortOrder: 'country', canSort: true },
  { key: 'submittedBy', label: 'Submitted By', sortOrder: 'submittedBy', canSort: true },
  { key: 'submitteddate', label: 'Submitted Date', sortOrder: 'submitteddate', canSort: true },
  { key: 'status', label: 'Status', sortOrder: 'status', canSort: true },
]

export const TRAINING_TABLE_COLUMNS = [
  { key: 'trainingTrackId', label: 'Training Track ID', sortOrder: 'trainingTrackId', canSort: true },
  { key: 'userCaseId', label: 'User Case ID', sortOrder: 'userCaseId', canSort: true },
  { key: 'line', label: 'Line', sortOrder: 'line', canSort: true },
  { key: 'type', label: 'Type', sortOrder: 'type', canSort: true },
  { key: 'wcn', label: 'WCN', sortOrder: 'wcn', canSort: true },
  { key: 'priority', label: 'Priority', sortOrder: 'priority', canSort: true },
  { key: 'quarter', label: 'Quarter', sortOrder: 'quarter', canSort: true },
  { key: 'rank', label: 'Rank', sortOrder: 'rank', canSort: true },
  { key: 'tpc', label: 'TPC', sortOrder: 'tpc', canSort: true },
  { key: 'submittedDate', label: 'Submitted Date', sortOrder: 'submittedDate', canSort: true },
  { key: 'status', label: 'Status', sortOrder: 'status', canSort: true },
]

export const trainingSampleData = [
  {
    trainingTrackId: '000001',
    userCaseId: '000001',
    line: '001',
    type: 'IMET',
    wcn: 'WCN-1001',
    priority: 'A',
    quarter: 'Q1',
    rank: 'Officer',
    tpc: 'john.doe@example.com',
    submittedDate: '03/29/2026',
    status: 'Waiting For Training',
    ItemGUID: 'TT000023',
    grantItemGUID: '000023'
  },
  {
    trainingTrackId: '000002',
    userCaseId: '000002',
    line: '002',
    type: 'IMET',
    wcn: 'WCN-1002',
    priority: 'B',
    quarter: 'Q2',
    rank: 'Officer',
    tpc: 'jane.smith@example.com',
    submittedDate: '03/30/2026',
    status: 'Waiting For Training',
    ItemGUID: 'TT000024',
    grantItemGUID: '000023'
  },
  {
    trainingTrackId: '000003',
    userCaseId: '000003',
    line: '001',
    type: 'FMF',
    wcn: 'WCN-1003',
    priority: 'A',
    quarter: 'Q1',
    rank: 'Enlisted',
    tpc: 'mike.johnson@example.com',
    submittedDate: '03/31/2026',
    status: 'Waiting For Training',
    ItemGUID: 'TT000025',
    grantItemGUID: '000024'
  },
  {
    trainingTrackId: '000004',
    userCaseId: '000004',
    line: '001',
    type: 'IMET',
    wcn: 'WCN-1004',
    priority: 'C',
    quarter: 'Q3',
    rank: 'Officer',
    tpc: 'sara.lee@example.com',
    submittedDate: '03/28/2026',
    status: 'Waiting For Training',
    ItemGUID: 'TT000026',
    grantItemGUID: '000025'
  },
  {
    trainingTrackId: '000005',
    userCaseId: '000005',
    line: '001',
    type: 'FMF',
    wcn: 'WCN-1005',
    priority: 'B',
    quarter: 'Q4',
    rank: 'Enlisted',
    tpc: 'chris.brown@example.com',
    submittedDate: '03/27/2026',
    status: 'Waiting For Training',
    ItemGUID: 'TT000027',
    grantItemGUID: '000026'
  },
]
export const TRAINING_STATUS_LABEL: Record<number, string> = {
    1: 'Saved',
    2: 'Submitted',
    3: 'Canceled',
    4: 'Waiting for Seat Validation',
    5: 'Waiting for Execution',
    6: 'Waiting for Utilization',
    7: 'Waiting for Billing',
    8: 'Waiting for Reconciliation',
    9: 'Waiting for Closure',
}
export const CASE_LIST_TABLE_COLUMNS = [
  { key: 'requestID', label: 'ID', canSort: true },
  { key: 'title', label: 'Title', canSort: true },
  { key: 'caseType', label: 'Case Type', canSort: true },
  { key: 'country', label: 'Country', canSort: true },
  { key: 'organization', label: 'Organization', canSort: true },
  { key: 'priority', label: 'Priority', canSort: true },
  { key: 'submittedDate', label: 'Submitted Date', canSort: true },
  { key: 'status', label: 'Status', canSort: true }
]

export const caseListviewData = [
  {
    requestID: '00050',
    title: 'Fighter Jet Procurement',
    caseType: 'Equipment',
    country: 'Africa',
    organization: 'Ministry of Defence',
    priority: 'High',
    submittedDate: '03/30/2026',
    status: 'Waiting for Analyst Review',
    ItemGUID: '000001'
  },
  {
    requestID: '00049',
    title: 'Fighter Jet Procurement',
    caseType: 'Equipment',
    country: 'Africa',
    organization: 'Ministry of Defence',
    priority: 'High',
    submittedDate: '03/30/2026',
    status: 'Waiting for Analyst Review',
    ItemGUID: '000002'
  },
  {
    requestID: '00048',
    title: 'Fighter Jet Procurement',
    caseType: 'Equipment',
    country: 'Africa',
    organization: 'Ministry of Defence',
    priority: 'High',
    submittedDate: '03/30/2026',
    status: 'Waiting for Analyst Review',
    ItemGUID: '000003'
  },
  {
    requestID: '00047',
    title: 'Fighter Jet Procurement',
    caseType: 'Equipment',
    country: 'Africa',
    organization: 'Ministry of Defence',
    priority: 'High',
    submittedDate: '03/30/2026',
    status: 'Waiting for Analyst Review',
    ItemGUID: '000004'
  },
]

export type HomeNewFilterValue = {
  label: string
  value: string
}

export type HomeNewFilterState = Record<string, { order: number; value: HomeNewFilterValue[] }>

export type HomeNewRequirementItem = {
  ID: number
  ItemGuid: string
  requestID: string
  fiscalYear: string
  caseType: string
  country: string
  ia: string
  programtype: string
  organization: string
  trainingType: string
  status: string
  ceilingUSD: string
  submittedDate: string
}

type HomeNewFilterConfigItem = {
  key: keyof Pick<HomeNewRequirementItem, 'fiscalYear' | 'country' | 'ia' | 'programtype' | 'ceilingUSD'>
  label: string
}

const HOME_NEW_FILTER_CONFIG: HomeNewFilterConfigItem[] = [
  { key: 'fiscalYear', label: 'Fiscal Year' },
  { key: 'country', label: 'Country' },
  { key: 'ia', label: 'IA' },
  { key: 'programtype', label: 'Program Type' },
]

export const HOME_NEW_REQUIREMENTS: HomeNewRequirementItem[] = [
  { ID: 1, ItemGuid: 'case-001', requestID: 'REQ-10001', fiscalYear: '2026', ia: 'B', programtype: 'IMET', trainingType: 'IMS', caseType: 'Training', country: 'BA', organization: 'DSCA', status: 'In Progress', submittedDate: '2026-04-01' },
  { ID: 2, ItemGuid: 'case-002', requestID: 'REQ-10002', fiscalYear: '2025', ia: 'A', programtype: 'IMET', trainingType: 'IMS', caseType: 'Equipment', country: 'JO', organization: 'Army', status: 'Completed', submittedDate: '2026-04-03' },
  { ID: 3, ItemGuid: 'case-003', requestID: 'REQ-10003', fiscalYear: '2026', ia: 'N', programtype: 'CN', trainingType: 'IMS', caseType: 'Training', country: 'TH', organization: 'Navy', status: 'Completed', submittedDate: '2026-04-05' },
  { ID: 4, ItemGuid: 'case-004', requestID: 'REQ-10004', fiscalYear: '2026', ia: 'B', programtype: 'IMET', trainingType: 'IMS', caseType: 'Training', country: 'BA', organization: 'USAF', status: 'In Progress', submittedDate: '2026-04-08' },
  { ID: 5, ItemGuid: 'case-005', requestID: 'REQ-10005', fiscalYear: '2026', ia: 'A', programtype: 'CN', trainingType: 'IMS', caseType: 'Equipment', country: 'JO', organization: 'DSCA', status: 'Completed', submittedDate: '2026-04-09' },
  { ID: 6, ItemGuid: 'case-006', requestID: 'REQ-10006', fiscalYear: '2026', ia: 'N', programtype: 'IMET', trainingType: 'IMS', programtype: 'IMET', caseType: 'Training', country: 'TH', organization: 'Army', status: 'In Progress', submittedDate: '2026-04-11' },
  { ID: 7, ItemGuid: 'case-007', requestID: 'REQ-10007', fiscalYear: '2026', ia: 'B', programtype: 'IMET', trainingType: 'IMS', caseType: 'Training', country: 'BA', organization: 'Navy', status: 'Completed', submittedDate: '2026-04-14' },
  { ID: 8, ItemGuid: 'case-008', requestID: 'REQ-10008', fiscalYear: '2026', ia: 'A', programtype: 'CN', trainingType: 'IMS', caseType: 'Equipment', country: 'JO', organization: 'USAF', status: 'In Progress', submittedDate: '2026-04-18' },
]

const uniqueOptions = (items: HomeNewRequirementItem[], key: HomeNewFilterConfigItem['key']) => {
  return [...new Set(items.map((item) => item[key]).filter(Boolean))].sort()
}

export const buildHomeNewFilterConfig = (items: HomeNewRequirementItem[]) => {
  return HOME_NEW_FILTER_CONFIG.map((entry) => ({
    ...entry,
    isMulti: false,
    defaultValue: 'All',
    options: [
      { label: 'All', value: 'All' },
      ...uniqueOptions(items, entry.key).map((value) => ({ label: value, value })),
    ],
  }))
}

export const buildHomeNewInitialFilters = (config: Array<{ key: string; defaultValue?: string }>): HomeNewFilterState => {
  const initialFilters: HomeNewFilterState = {}

  config.forEach((entry, index) => {
    initialFilters[entry.key] = {
      order: index + 1,
      value: [{ label: entry.defaultValue ?? 'All', value: entry.defaultValue ?? 'All' }],
    }
  })

  return initialFilters
}

export const filterHomeNewRequirements = (
  items: HomeNewRequirementItem[],
  filters: Record<string, { value?: HomeNewFilterValue[] }>,
  searchText: string
) => {
  const query = searchText.trim().toLowerCase()

  return items.filter((item) => {
    const searchMatch = !query || [
      item.requestID,
      item.caseType,
      item.country,
      item.organization,
      item.status,
    ].some((value) => value != null && value.toLowerCase().includes(query))

    const filterMatch = HOME_NEW_FILTER_CONFIG.every((entry) => {
      const selected = filters[entry.key]?.value?.[0]?.value
      if (!selected || selected === 'All') return true
      return (item[entry.key] ?? '') === selected
    })

    return searchMatch && filterMatch
  })
}

export const HOME_NEW_DISPLAY = {
  totalCases: 42,
  inProgress: 19,
  completed: 25,
  averageCycle: 120,
  taskStatusCount: 80,
  taskStatusTotal: 98,
  monthlyTrainingCount: 50,
} as const

export const HOME_NEW_KPIS = [
  {
    title: 'Total Cases',
    value: HOME_NEW_DISPLAY.totalCases,
    iconname: 'icon-rb-total-requirements',
    ColorCode: '7',
    valuecolour: '7',
    showicon: true,
    isKpiBgcolor: true,
    layout: { showIcon: true, showSecondaryValue: true, iconPosition: 'left', secondaryValuePosition: 'below-title' },
    status: 'all',
  },
  {
    title: 'In Progress',
    value: HOME_NEW_DISPLAY.inProgress,
    iconname: 'icon-rb-in-progress',
    ColorCode: '8',
    valuecolour: '8',
    showicon: true,
    isKpiBgcolor: true,
    layout: { showIcon: true, showSecondaryValue: false, iconPosition: 'left', secondaryValuePosition: 'below-title' },
    status: 'In Progress',
  },
  {
    title: 'Completed',
    value: HOME_NEW_DISPLAY.completed,
    iconname: 'icon-rb-funded',
    ColorCode: '9',
    valuecolour: '9',
    showicon: true,
    isKpiBgcolor: true,
    layout: { showIcon: true, showSecondaryValue: false, iconPosition: 'left', secondaryValuePosition: 'below-title' },
    status: 'Completed',
  },
  {
    title: 'Average Cycle (Days)',
    value: HOME_NEW_DISPLAY.averageCycle,
    iconname: 'icon-rb-clock-1',
    ColorCode: '10',
    valuecolour: '10',
    showicon: true,
    isKpiBgcolor: true,
    layout: { showIcon: true, showSecondaryValue: false, iconPosition: 'left', secondaryValuePosition: 'below-title' },
    status: 'all',
  },
] as const

export const HOME_NEW_TYPE_DATA = [
  { name: 'Equipment', value: 12, fill: '#8A2BE2' },
  { name: 'Training', value: 38, fill: '#3148C6' },
] as const

export const HOME_NEW_TYPE_DONUT_CONFIG = {
  chartType: 'donut',
  dataKey: 'value',
  nameKey: 'name',
  container_width: '100%',
  container_height: 220,
  innerRadius: 58,
  outerRadius: 84,
  data: HOME_NEW_TYPE_DATA,
  label: { label: false },
  legend: { legend: false },
}

export const HOME_NEW_CASE_STATUS_BAR_CONFIG = {
  chartType: 'bar',
  dataKey: 'name',
  container_width: '100%',
  container_height: 220,
  fill: true,
  stroke: false,
  barSize: 22,
  data: [
    { name: 'Archived', value: 6.1 },
    { name: 'Low Priori', value: 2.3 },
    { name: 'USA Appvl', value: 5.7 },
    { name: 'Identity', value: 4.3 },
    { name: 'Within Pr', value: 5.6 },
  ],
  series: [{ dataKey: 'value', color: '#7A1FE5' }],
  cartesianGrid: { stroke: '#E7EAF3', vertical: false },
  xAxis: { axisLine: false, tickLine: false, interval: 0, tickMargin: 10, height: 40 },
  yAxis: { axisLine: { stroke: '#CBD5E1' }, tickLine: false, ticks: [0, 2, 4, 6, 8], width: 32, label: { value: 'Cases', angle: -90, position: 'insideLeft', style: { textAnchor: 'middle' } } },
  legend: { legend: false },
}

export const HOME_NEW_PRIORITY_DATA = [
  { name: 'High', value: 11, fill: '#B23319' },
  { name: 'Medium', value: 20, fill: '#8A7500' },
  { name: 'Low', value: 11, fill: '#3D8637' },
] as const

export const HOME_NEW_PRIORITY_DONUT_CONFIG = {
  chartType: 'donut',
  dataKey: 'value',
  nameKey: 'name',
  ariaLabel: 'By Priority',
  title:'By Priority',
  container_width: '100%',
  container_height: 220,
  innerRadius: 58,
  outerRadius: 84,
  data: HOME_NEW_PRIORITY_DATA,
  label: { label: false },
  legend: { legend: false },
}

export const HOME_NEW_TASK_STATUS_DATA = [
  { name: 'Requested', value: 20, fill: '#007387' },
  { name: 'Confirmed', value: 32, fill: '#A8B819' },
  { name: 'Denied', value: 18, fill: '#D15305' },
] as const

export const HOME_NEW_TASK_STATUS_DONUT_CONFIG = {
  chartType: 'donut',
  dataKey: 'value',
  nameKey: 'name',
  container_width: '100%',
  container_height: 220,
  innerRadius: 58,
  outerRadius: 84,
  data: HOME_NEW_TASK_STATUS_DATA,
  label: { label: false },
  legend: { legend: false },
}

export const HOME_NEW_PROGRAM_TYPE_DATA = [
  { name: 'FMF', value: 20, fill: '#8722E4' },
  { name: 'IMET', value: 20, fill: '#3148C6' },
  { name: 'Other Programs', value: 10, fill: '#6874A6' },
] as const

export const HOME_NEW_TRAINING_STATUS_BAR_CONFIG = {
  chartType: 'bar',
  dataKey: 'name',
  container_width: '100%',
  container_height: 220,
  ariaLabel: 'By Training Status',
  title: 'By Training Status',
  fill: true,
  stroke: false,
  barSize: 22,
  data: [
    { name: 'Seat Vali', value: 5.2 },
    { name: 'Training', value: 4.5 },
    { name: 'Billing', value: 4.9 },
    { name: 'Reconcil', value: 3.7 },
    { name: 'Closure', value: 1.8 },
    { name: 'Cancel', value: 0.7 },
  ],
  series: [{ dataKey: 'value', color: '#237F92' }],
  cartesianGrid: { stroke: '#E7EAF3', vertical: false },
  xAxis: { axisLine: false, tickLine: false, interval: 0, tickMargin: 10, height: 40 },
  yAxis: { axisLine: { stroke: '#CBD5E1' }, tickLine: false, ticks: [0, 2, 4, 6], width: 52, label: { value: 'Cases', angle: -90, position: 'insideLeft', style: { textAnchor: 'middle' } } },
  legend: { legend: false },
}

export const HOME_NEW_FUNDING_STATUS_DATA = [
  { name: 'Funded', value: 32, fill: '#4F09C9' },
  { name: 'Unfunded', value: 18, fill: '#976E17' },
] as const

export const HOME_NEW_FUNDING_STATUS_PIE_CONFIG = {
  chartType: 'pie',
  dataKey: 'value',
  nameKey: 'name',
  ariaLabel: 'By Funding Status',
  title: 'By Funding Status',
  container_width: '100%',
  container_height: 220,
  outerRadius: 84,
  data: HOME_NEW_FUNDING_STATUS_DATA,
  label: { label: false },
  legend: { legend: false },
}

export const HOME_NEW_GRANT_UTILIZATION_CONFIG = {
  chartType: 'composed',
  dataKey: 'name',
  ariaLabel: 'By Grant Util. vs Ceiling',
  title: 'By Grant Util. vs Ceiling',
  container_width: '100%',
  container_height: 220,
  data: [
    { name: 'Jan', utilized: 2, remaining: 1 },
    { name: 'Feb', utilized: 12, remaining: 9 },
    { name: 'Mar', utilized: 10, remaining: 7 },
    { name: 'Apr', utilized: 8, remaining: 6 },
    { name: 'May', utilized: 13, remaining: 9 },
    { name: 'Jun', utilized: 9, remaining: 5 },
    { name: 'Jul', utilized: 18, remaining: 12 },
    { name: 'Aug', utilized: 15, remaining: 10 },
    { name: 'Sep', utilized: 19, remaining: 11 },
    { name: 'Oct', utilized: 7, remaining: 4 },
    { name: 'Nov', utilized: 16, remaining: 8 },
    { name: 'Dec', utilized: 40, remaining: 22 },
  ],
  series: [
    { dataKey: 'utilized', chartType: 'line', color: '#36A953', strokeWidth: 2.5, dot: false },
    { dataKey: 'remaining', chartType: 'line', color: '#C23FC7', strokeWidth: 2.5, dot: false },
  ],
  cartesianGrid: { stroke: '#E7EAF3', vertical: false },
  xAxis: { axisLine: false, tickLine: false, interval: 0, tickMargin: 8 },
  yAxis: { axisLine: { stroke: '#CBD5E1' }, tickLine: false, ticks: [0, 10, 20, 30, 40], width: 52, label: { value: 'Cases', angle: -90, position: 'left', offset: 0, style: { textAnchor: 'middle' } } },
  legend: { legend: false },
}

export const HOME_NEW_MONTHLY_CALENDAR = {
  label: 'April 2026',
  weekdays: ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'],
  days: [
    '', '', '', '1', '2', '3', '4',
    '5', '6', '7', '8', '9', '10', '11',
    '12', '13', '14', '15', '16', '17', '18',
    '19', '20', '21', '22', '23', '24', '25',
    '26', '27', '28', '29', '30', '', '',
  ],
  eventDays: [6, 20],
} as const

export const HOME_NEW_UPCOMING_TRAININGS = [
  { id: 1, date: '06', title: 'Army IMT | WOT 9607-A', meta: '09:00 AM-11:30 AM' },
  { id: 2, date: '13', title: 'Army IMT | WOT 9607-A', meta: '09:00 AM-11:30 AM' },
  { id: 3, date: '20', title: 'Army IMT | WOT 9607-A', meta: '10:30 AM-1:00 PM' },
  { id: 4, date: '27', title: 'Army IMT | WOT 9607-A', meta: '09:00 AM-11:30 AM' },
]

export const HOME_NEW_TMASL_BAR_CONFIG = {
  chartType: 'bar',
  layout: 'vertical',
  container_width: '100%',
  container_height: 280,
  fill: true,
  ariaLabel: 'By Top T-MASL Demand',
  title: 'By Top T-MASL Demand',
  stroke: false,
  barSize: 20,
  barCategoryGap: '8%',
  data: [
    { name: 'B-123456', value: 16, fill: '#365FB7' },
    { name: 'B-123457', value: 10, fill: '#365FB7' },
    { name: 'B-123458', value: 24, fill: '#365FB7' },
    { name: 'B-123459', value: 15, fill: '#365FB7' },
  ],
  series: [{ dataKey: 'value', color: 'fill' }],
  cartesianGrid: { stroke: '#E7EAF3', vertical: false, horizontal: false },
  xAxis: { type: 'number', dataKey: 'value', axisLine: false, tickLine: false, domain: [0, 'auto'], tickCount: 4, label: { value: 'Training Load', position: 'bottom', offset: -7 } },
  yAxis: { type: 'category', dataKey: 'name', axisLine: { stroke: '#CBD5E1' }, tickLine: false, width: 72 },
  legend: { legend: false },
}

export const HOME_NEW_CALENDAR_EVENTS = [
  { ID: 1, title: 'Training Session', EventDate: '2026-03-27T09:00:00', EndDate: '2026-03-27T11:30:00', FreeBusy: null, rrule: null, extendedProps: {}, _instance: null, _def: null },
  { ID: 2, title: 'Leadership Meeting', EventDate: '2026-03-28T09:00:00', EndDate: '2026-03-28T11:30:00', FreeBusy: null, rrule: null, extendedProps: {}, _instance: null, _def: null },
  { ID: 3, title: 'General Meeting', EventDate: '2026-03-29T09:00:00', EndDate: '2026-03-29T11:30:00', FreeBusy: null, rrule: null, extendedProps: {}, _instance: null, _def: null },
]

export const HOME_NEW_QUICK_LINKS = [
  { ID: 1, Title: 'Training', URL: 'https://example.com/training', IsArchived: false },
  { ID: 2, Title: 'Maintenance Support', URL: 'https://example.com/maintenance-support', IsArchived: false },
  { ID: 3, Title: 'Delivery', URL: 'https://example.com/delivery', IsArchived: false },
  { ID: 4, Title: 'Medical Inspections', URL: 'https://example.com/medical-inspections', IsArchived: false },
  { ID: 5, Title: 'Terms & Conditions', URL: 'https://example.com/terms-and-conditions', IsArchived: false },
  { ID: 6, Title: 'Warranty Information', URL: 'https://example.com/warranty-information', IsArchived: false },
  { ID: 7, Title: 'Technical Requirements', URL: 'https://example.com/technical-requirements', IsArchived: false },
  { ID: 8, Title: 'Invoice & Billing Information', URL: 'https://example.com/invoice-billing-information', IsArchived: false },
]

export const HOME_NEW_POC_DATA = [
  { ID: 1, ContactName: 'Terry Terry', ContactTitle: 'Analyst', ContactEmail: 'terry.terry@gmail.com', ContactPhone: '', IsArchived: false },
  { ID: 2, ContactName: 'Marcus Booth', ContactTitle: 'Analyst', ContactEmail: 'marcus.booth@gmail.com', ContactPhone: '', IsArchived: false },
  { ID: 3, ContactName: 'Nolan Korsgaard', ContactTitle: 'Program Manager', ContactEmail: 'nolan.korsgaard@gmail.com', ContactPhone: '', IsArchived: false },
]

export type DetailViewField = {
  label: string
  value: string
}

export type DetailViewProgressStep = {
  label: string
  progressPeriod?: string
  statusType?: 'completed' | 'active' | ''
  history?: Array<{
    user: string
    dateTime: string
  }>
}

export type CaseDetailViewProgressStep = {
  label: string
  progressPeriod?: string
  statusType?: 'completed' | 'active' | 'Created' | ''
  Status?: string
  history?: Array<{
    user: string
    dateTime: string
    statusLabel?: string
  }>
}

export type DetailViewTrainingLine = {
  studentName: string
  rank: string
  suffix: string
  tmasl: string
  priority: string
  reportDate: string
  startDate: string
  endDate: string
  location: string
  exa: string
  financialStatus: string
}

export type DetailViewPerson = {
  ID: number
  Title: string
  EMail: string
  Email?: string
  DisplayText?: string
  Id?: number
}

export type DetailViewFileItem = {
  UniqueId: string
  Name: string
  ServerRelativeUrl: string
  Title?: string
  Author?: {
    Title?: string
  }
  TimeCreated?: string
  ItemCreated?: string
  ItemCreatedBy?: {
    Title: string
    Email?: string
    Id?: number
  }
}

export type DetailViewFolderItem = {
  title: string
  files: DetailViewFileItem[]
}

export type DetailViewComment = {
  Id: number
  Subject?: string
  Comment: string
  CommentType?: string
  CommentTo?: string
  DocumentName?: string
  ParentCommentID?: number
  IsActionComment?: boolean
  ItemCreated: string
  ItemCreatedBy: {
    Title: string
    Email?: string
    Id?: number
  }
}

export const DETAIL_VIEW_NEW_HEADER = {
  requestId: '000001',
  owner: 'John Doe',
  pageTitle: 'Grant Detail',
} as const

export const DETAIL_VIEW_NEW_ACTIONS = [
  { key: 'cancel', label: 'Cancel', leftIcon: 'icon-rb-disable', variant: 'primary', className: 'detail-view-new-action detail-view-new-action-cancel', pill: true, style: { '--rb-btn-bg': '#C0622F' } },
  { key: 'back', label: 'Back', leftIcon: 'icon-rb-arrow-left', className: 'detail-view-new-action detail-view-new-action-back', style: { '--rb-btn-bg': '#fff', '--rb-btn-border': '#D2D2D2', '--rb-btn-text': '#000', '--rb-btn-hover-border': '#D2D2D2' } },
] as const

export const DETAIL_VIEW_NEW_HEADLINE_FIELDS: DetailViewField[] = [
  { label: 'Fiscal Year', value: '2026' },
  { label: 'Country', value: 'Saudi Arabia' },
  { label: 'IA', value: 'B' },
  { label: 'Program Type', value: 'Grant' },
  { label: 'Ceiling (USD)', value: '$50,000' },
  { label: 'Utilized (USD)', value: '$5,000' },
  { label: 'Remaining (USD)', value: '$45,000' },
  { label: 'Utilization %', value: '0.01' },
  { label: 'Submitted Date', value: '03/29/2026' },
] as const

export const DETAIL_VIEW_NEW_PROGRESS_STEPS: DetailViewProgressStep[] = [
  { label: 'Initiated', statusType: 'completed', history: [{ user: 'John Doe', dateTime: '03/29/2026 03:45 PM' }] },
  { label: 'Internal Review', statusType: 'active', history: [{ user: 'John Doe', dateTime: '03/29/2026 03:45 PM' }] },
  { label: 'DSCA Funding', statusType: '', history: [{ user: 'DSCA Funding', dateTime: '03/30/2026 09:15 AM' }] },
  { label: 'Implemented', statusType: '', history: [{ user: 'Implemented', dateTime: '04/02/2026 01:05 PM' }] },
  { label: 'Active', statusType: '', history: [{ user: 'Active', dateTime: '04/10/2026 08:30 AM' }] },
  { label: 'Closed', statusType: '', history: [{ user: 'Closed', dateTime: '05/01/2026 10:20 AM' }] },
] as const

export const TRAINING_TRACK_SUMMARY_FIELDS: DetailViewField[] = [
  { label: 'User Case ID', value: 'BA-B-26B' },
  { label: 'Line', value: '001' },
  { label: 'Type', value: 'IMS' },
  { label: 'WCN', value: '1001' },
  { label: 'Priority', value: 'A' },
  { label: 'Fiscal Year', value: '2026' },
  { label: 'Quarter', value: '2' },
  { label: 'Rank', value: 'Officer' },
  { label: 'TPC', value: 'John Doe' },
  { label: 'Training Person First Name', value: 'Justin' },
  { label: 'Training Person Last Name', value: 'Smith' },
  { label: 'Training Person Middle Name', value: 'Herwitz' },
  { label: 'Vetted', value: '1' },
]


export const TRAINING_DETAIL_VIEW_DESCRIPTION = 'This training effort represents the execution phase of an approved grant, supporting a partner nation through structured training programs aligned to defined requirements and objectives. Each training track is established for individual participants and includes assigned courses (T-MASL), schedules, and associated costs. This training effort represents the execution phase of an approved grant, supporting a partner nation through structured training programs aligned to their requirements and objectives. Each training track is established for individual participants and includes assigned courses (T-MASL), schedules, and associated costs.'

export const TRAINING_DETAIL_VIEW_PROGRESS_STEPS: DetailViewProgressStep[] = [
  { label: 'Submitted', statusType: 'completed', history: [{ user: 'Submitted', dateTime: '05/29/2026 03:45 PM' }] },
  { label: 'Sent Validation', statusType: 'active', history: [{ user: 'Sent Validation', dateTime: '05/30/2026 04:00 PM' }] },
  { label: 'Execution', statusType: '', history: [{ user: 'Execution', dateTime: '06/01/2026 09:00 AM' }] },
  { label: 'Utilization', statusType: '', history: [{ user: 'Utilization', dateTime: '06/05/2026 10:30 AM' }] },
  { label: 'Billing', statusType: '', history: [{ user: 'Billing', dateTime: '06/10/2026 08:00 AM' }] },
  { label: 'Reconciliation', statusType: '', history: [{ user: 'Reconciliation', dateTime: '04/28/2026 02:00 PM' }] },
  { label: 'Closure', statusType: '', history: [{ user: 'Closure', dateTime: '06/20/2026 10:20 AM' }] },
]

export const CASE_DETAIL_VIEW_NEW_PROGRESS_STEPS: CaseDetailViewProgressStep[] = [
  { label: 'Initiated', statusType: 'completed', Status: 'Initiated', history: [{ user: 'Program Office', statusLabel: 'Completed', dateTime: '03/29/2026 03:00 PM' }] },
  { label: 'Analyst', statusType: 'active', Status: 'Analyst', history: [{ user: 'John Doe', statusLabel: 'Created', dateTime: '03/29/2026 03:45 PM' }] },
] as const

export const DETAIL_VIEW_NEW_SUMMARY_FIELDS: DetailViewField[] = [
  { label: 'Case Type', value: 'Grants' },
  // { label: 'Program Type', value: 'Aviation Leadership Program (ALP)' },
  // { label: 'IA', value: 'B' },
  // { label: 'Country', value: 'BA' },
  // { label: 'Case Designator', value: '26B' },
  // { label: 'User Case ID', value: 'BA-B-26B' },
  // { label: 'Fiscal Year', value: '2026' },
  // { label: 'End Fiscal Year', value: '2027' },
  // { label: 'Submitted by', value: 'John Doe' },
  // { label: 'Submitted Date', value: '03/29/2026' },
] as const

export const DETAIL_VIEW_NEW_TRAINING_LINES: DetailViewTrainingLine[] = [
  { studentName: 'Justin Herwitz', rank: 'Officer', suffix: 'A', tmasl: 'B1234567', priority: 'A', reportDate: '04/12/2026', startDate: '04/16/2026', endDate: '05/29/2026', location: 'BAAA', exa: 'BAX', financialStatus: 'Funded' },
  { studentName: 'Justin Herwitz', rank: 'Officer', suffix: 'A', tmasl: 'B1234567', priority: 'A', reportDate: '04/12/2026', startDate: '04/16/2026', endDate: '05/29/2026', location: 'BAAA', exa: 'BAX', financialStatus: 'Funded' },
  { studentName: 'Corey Dias', rank: 'Officer', suffix: 'A', tmasl: 'B1234567', priority: 'A', reportDate: '04/12/2026', startDate: '04/16/2026', endDate: '05/29/2026', location: 'BAAA', exa: 'BAX', financialStatus: 'Funded' },
] as const

export const DETAIL_VIEW_NEW_DESCRIPTION = 'This grant represents a partner nation request executed under an approved program, providing funding for defense equipment, training, and associated support services aligned to defined requirements and strategic objectives. The grant establishes the financial framework, including allocated funding, spending limits, and fiscal oversight, to support execution activities. This grant supports services aligned to defined requirements and strategic objectives. The grant establishes the financial framework, including allocated funding, spending limits, and fiscal oversight, to support execution activities. This grant supports services aligned to defined requirements and strategic objectives.'

export const DETAIL_VIEW_NEW_FILES: DetailViewFileItem[] = [] as const

export const DETAIL_VIEW_NEW_FOLDERS: DetailViewFolderItem[] = [
  {
    title: 'General (02)',
    files: [
      {
        UniqueId: 'file-1',
        Name: 'Request_Letter.pdf',
        Title: 'Request_Letter.pdf',
        ServerRelativeUrl: '/static/Request_Letter.pdf',
        Author: { Title: 'John Doe' },
        TimeCreated: '2026-03-29T15:45:00',
        ItemCreated: '2026-03-29T15:45:00',
        ItemCreatedBy: { Title: 'John Doe', Email: 'john.doe@example.com', Id: 1 },
      },
      {
        UniqueId: 'file-2',
        Name: 'Country_Request_Details.docx',
        Title: 'Country_Request_Details.docx',
        ServerRelativeUrl: '/static/Country_Request_Details.docx',
        Author: { Title: 'John Doe' },
        TimeCreated: '2026-03-29T15:45:00',
        ItemCreated: '2026-03-29T15:45:00',
        ItemCreatedBy: { Title: 'John Doe', Email: 'john.doe@example.com', Id: 1 },
      },
    ],
  },
  {
    title: 'Grant (01)',
    files: [
      {
        UniqueId: 'file-3',
        Name: 'Support Document.pdf',
        Title: 'Support Document.pdf',
        ServerRelativeUrl: '/static/Support_Document.pdf',
        Author: { Title: 'John Doe' },
        TimeCreated: '2026-03-29T15:45:00',
        ItemCreated: '2026-03-29T15:45:00',
        ItemCreatedBy: { Title: 'John Doe', Email: 'john.doe@example.com', Id: 1 },
      },
    ],
  },
] as const

export const DETAIL_VIEW_NEW_TEAM_MEMBERS: DetailViewPerson[] = [
  // { ID: 1, Id: 1, Title: 'Ryan Schleifer', DisplayText: 'Ryan Schleifer', EMail: 'ryan.schleifer@ideaentity.com', Email: 'ryan.schleifer@ideaentity.com' },
  // { ID: 2, Id: 2, Title: 'Nolan Korsgaard', DisplayText: 'Nolan Korsgaard', EMail: 'nolan.korsgaard@ideaentity.com', Email: 'nolan.korsgaard@ideaentity.com' },
  // { ID: 3, Id: 3, Title: 'Terry Torff', DisplayText: 'Terry Torff', EMail: 'terry.torff@ideaentity.com', Email: 'terry.torff@ideaentity.com' },
] as const

export const DETAIL_VIEW_NEW_PEOPLE_SUGGESTIONS: DetailViewPerson[] = [
  { ID: 11, Id: 11, Title: 'Justin Herwitz', DisplayText: 'Justin Herwitz', EMail: 'justin.herwitz@example.com', Email: 'justin.herwitz@example.com' },
  { ID: 12, Id: 12, Title: 'Cristofer George', DisplayText: 'Cristofer George', EMail: 'cristofer.george@example.com', Email: 'cristofer.george@example.com' },
  { ID: 13, Id: 13, Title: 'Sarah Miller', DisplayText: 'Sarah Miller', EMail: 'sarah.miller@example.com', Email: 'sarah.miller@example.com' },
  { ID: 14, Id: 14, Title: 'Nolan Korsgaard', DisplayText: 'Nolan Korsgaard', EMail: 'nolan.korsgaard@example.com', Email: 'nolan.korsgaard@example.com' },
] as const

export const DETAIL_VIEW_NEW_DISCUSSIONS: DetailViewComment[] = [
  {
    Id: 1,
    Subject: 'Upload Documents',
    Comment: 'This grant represents a partner nation request executed under an approved program, providing funding for defense equipment, training, and associated support services aligned to defined requirements and strategic objectives. The grant establishes the financial framework, including allocated funding, spending limits, and fiscal oversight, to support execution activities.',
    CommentType: 'Public',
    CommentTo: 'John Doe',
    DocumentName: 'Request_Letter.pdf',
    ParentCommentID: 0,
    IsActionComment: false,
    ItemCreated: '2026-03-29T15:45:00',
    ItemCreatedBy: { Title: 'John Doe', Email: 'john.doe@example.com', Id: 1 },
  },
  {
    Id: 2,
    Subject: 'Upload Required Documents',
    Comment: 'This grant represents a partner nation request executed under an approved program, providing funding for defense equipment, training, and associated support services aligned to defined requirements and strategic objectives. This grant supports services aligned to defined requirements and strategic objectives.',
    CommentType: 'Public',
    CommentTo: 'Ryan Schleifer',
    ParentCommentID: 0,
    IsActionComment: false,
    ItemCreated: '2026-03-29T15:45:00',
    ItemCreatedBy: { Title: 'John Doe', Email: 'john.doe@example.com', Id: 1 },
  },
] as const

export const DETAIL_VIEW_NEW_STATUS_NOTES: DetailViewComment[] = [
  {
    Id: 101,
    Subject: 'Internal Review Started',
    Comment: 'Internal review opened and the package was routed for initial validation.',
    IsActionComment: true,
    ItemCreated: '2026-03-29T09:15:00',
    ItemCreatedBy: { Title: 'John Doe', Email: 'john.doe@example.com', Id: 1 },
  },
  {
    Id: 102,
    Subject: 'Execution Package Ready',
    Comment: 'Funding package compiled with the latest routing notes and attached support memo.',
    IsActionComment: true,
    ItemCreated: '2026-04-02T13:05:00',
    ItemCreatedBy: { Title: 'Ryan Schleifer', Email: 'ryan.schleifer@example.com', Id: 1 },
  },
  {
    Id: 103,
    Subject: 'Implementation Scheduled',
    Comment: 'Implementation was scheduled and the grant package moved to the active queue.',
    IsActionComment: true,
    ItemCreated: '2026-04-06T10:00:00',
    ItemCreatedBy: { Title: 'Nolan Korsgaard', Email: 'nolan.korsgaard@example.com', Id: 2 },
  },
] as const

export const CASE_TABLE_COLUMNS = [
  { key: 'requestID', label: 'ID', canSort: true },
  { key: 'title', label: 'Title', canSort: true },
  { key: 'description', label: 'Description', canSort: true },
  { key: 'assignedTo', label: 'Assigned To', canSort: true },
  { key: 'priority', label: 'Priority', canSort: true },
  { key: 'dueDate', label: 'Due Date', canSort: true },
  { key: 'status', label: 'Status', canSort: true }
]

export const caseDetailviewData = [
  {
    requestID: '00050',
    title: 'Fighter Aircraft',
    description: 'LOR received and the initial review',
    assignedTo: 'Ryan Schleifer',
    priority: 'High',
    dueDate: '03/31/2026',
    status: 'Not Started',
    ItemGUID: '000001'
  },
  {
    requestID: '00049',
    title: 'Review LOR',
    description: 'Analyze the request details',
    assignedTo: 'Ryan Schleifer',
    priority: 'High',
    dueDate: '03/22/2026',
    status: 'Overdue',
    ItemGUID: '000002'
  },
  {
    requestID: '00048',
    title: 'Tech Specifications',
    description: 'Verify that the requested equipment',
    assignedTo: 'Terry Torff',
    priority: 'High',
    dueDate: '03/30/2026',
    status: 'Completed',
    ItemGUID: '000003'
  },
  {
    requestID: '00047',
    title: 'Prepare Cost Estimate',
    description: 'Estimate total cost including equipment',
    assignedTo: 'Ryan Schleifer',
    priority: 'High',
    dueDate: '03/30/2026',
    status: 'Completed',
    ItemGUID: '000004'
  },
]

export const SessionTimeOut = 20 * 60 * 1000
export const RHYBUS_ACCESS_TOKEN = 'rhybustoken'
export const APP_NAME = 'DSCA-Dev'
export const CLIENT_CODE = 'clientcode'

export const getUserByUserId = async (userId: string): Promise<any> => {
  try {
    const userPickerModel = await rhybusWhoHttp().OtherByUserId(userId)
    // Map IPickerModel to IUser
    const user: any = {
      userId: userPickerModel.rid,
      isDirty: false,
      edipi: userPickerModel.edipi,
      email: userPickerModel.email,
      persona: userPickerModel.persona, // first and last name
      firstName: '',
      lastName: '',
      roles: [],
      roleCodes: []
    }
    return user
  } catch (error: any) {
    console.error(`Failed to fetch user with ID ${userId}:`, error)
    if (error.response && error.response.status === 404) {
      // Handle 404 error: user not found
      throw new Error(`User with ID ${userId} not found.`)
    }
    // Rethrow the error if it's not a 404 or you want to handle it differently
    throw error
  }
}
export function generateGUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}
export const USER_LOGIN_SESSIONID = 'X-User-Session-Id'
export const homeCalendarCategories = [
  { type: 'events', label: 'Events', color: '#C68112' },
  { type: 'trainings', label: 'Trainings', color: '#9E10AA' },
  { type: 'meetings', label: 'Meetings', color: '#0573E1' },
  { type: 'Work Hours', label: 'Work Hours', color: '#55be71' },
  { type: 'Business', label: 'Business', color: '#83badf' },
  { type: 'Holiday', label: 'Holiday', color: '#adc680' }
]
export const calendarFormConfig = [
  { id: 'title', label: 'Event Title', valueKey: 'Title', type: 'text',required: true, order: 1, maxLength: 255, placeholder: 'Enter Title' },
  { id: 'location', label: 'Location', valueKey: 'Location', type: 'text', order: 2, maxLength: 255, placeholder: 'Enter Location' },
  { id: 'startTime', label: 'Start Time', valueKey: 'StartTime', type: 'custom', required: true, order: 3, tooltip: 'Start Time' },
  { id: 'endTime', label: 'End Time', valueKey: 'EndTime', type: 'custom', required: true, order: 4, tooltip: 'End Time' },
  { id: 'allDay', label: 'All Day Event', valueKey: 'AllDayEvent', type: 'checkbox', order: 5, placeholder: "Make this an all-day event that doesn't start or end at a specific hour" },
  { id: 'recurrence', label: 'Recurrence', valueKey: 'Recurrence', type: 'checkbox', order: 6, placeholder: 'Make this repeating event' },
  { id: 'description', label: 'Description', valueKey: 'Description', type: 'textarea', order: 7, rows: 4, placeholder: 'Enter Description' },
  { id: 'category', label: 'Event Category', valueKey: 'Category', type: 'select', order: 8, options: ['Select Event Category', 'Meeting', 'Work Hours', 'Business', 'Holiday', 'Get Together'] },
  { id: 'attachments', label: 'Attach File(s)', valueKey: 'Attachments', type: 'file', order: 9 },
]
export const COLUMN_NAMES = {
  Year: 'Year',
  eTag: 'eTag',
  eKey: 'eKey',
  ItemGUID: 'ItemGUID',
  Path: 'Path',
  AppID: 'AppID',
  AppTitle: 'AppTitle',
  StatusCode: 'StatusCode',
  StatusTitle: 'StatusTitle',
  Company: 'Company',
  Location: 'Location',
  ArchivedDate: 'ArchivedDate',
  SubLocation: 'SubLocation',
  Category: 'Category',
  TimeWorked: 'TimeWorked',
  SubCategory: 'SubCategory',
  Impact: 'Impact',
  TicketCreatedFor: 'TicketCreatedFor',
  IsTicketCreatedForSelf: 'IsTicketCreatedForSelf',
  Description: 'Description',
  AssignTo: 'AssignTo',
  AssignRole: 'AssignRole',
  IsSubmitted: 'IsSubmitted',
  IsEmailTicket: 'IsEmailTicket',
  UserName: 'UserName',
  UserEmail: 'UserEmail',
  Priority: 'Priority',
  Severity: 'Severity',
  Action: 'Action',
  TeamMembers: 'TeamMembers',
  PreviousStatusTitle: 'PreviousStatusTitle',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemModifiedBy: 'ItemModifiedBy',
  ItemCreated: 'ItemCreated',
  ItemModified: 'ItemModified',
  Inprogress: ' Inprogress',
  IsDeleted: 'IsDeleted'
}
